import { ICommission } from "../../components/forms/inputs/commission";
import { IContractForService } from "../../components/forms/me/contractForService";
import { ITermsOfBusiness } from "../../components/forms/me/termsOfBusiness";
import { BookingType } from "../../_enums/bookingTypes.enum";
import { OccupationTypes } from "../../_enums/occipationTypes.enum";
import { ReferenceTypes } from "../../_enums/referenceTypes.enum";
import { ContactInterface } from "../../_models/data.contacts.model";
import { FieldValidaionModel } from "../../_models/data.fieldValidation.model";
import { IXeroClientContact } from "../../_models/data.xeroContact.model";
import { IInvoice, ILineItem } from "../../_types/xero";
import { isHeadteacherPosition } from "../helpers";
import { FormQuestionModuleType, FormQuestionType, IFormQuestion } from "../../state/context/formQuestions.store";
import { IStudent } from "../../_models/data.student.model";
import { IBranch } from "../../_models/data.branch.model";
import { IUmbrella } from "../../_models/data.umbrella.model";
import { ITarget } from "../../_models/data.target.model";
import { BookingCostsHolidayInterface } from "../../_types/bookings";
import { CandidateConfigOnboardingSteps, RequiredOnboardingFieldConfiguration } from "../../_models/data.candidateConfig.model";
import { IsNonUk, ShowFormQuestion, ValidateFileSize, ValidateFileType } from "../helpers";
import { IRates } from "../../components/forms/me/bookingRatesAmend";
import { RightToWork } from "../../_enums/rightToWork.enum";
import { CandidateEnquiryInterface } from "../../_models/data.candidateEnquiry.model";
import { ClientInterface } from "../../_types/client";
import { ICandidateInterviewQuestions } from "../../_models/data.candidateInterview.model";
import { IsValidTime } from "../../components/forms/inputs/time";
import { RightToWorkItem } from "../../hooks/useCustomerDocuments";
import { IPreviousAddress } from "../../_models/data.previousAddress.model";
import moment from "moment";
import { CandidatePay } from "../../_enums/candidatePay.enum";
import { shouldShowTrnField } from "../helpers/candidate";
import { validateNI } from "./niNumber";
import { MethodOfCitation } from "../../_enums/methodOfCitation.enum";
import { DocumentInterface } from "../../_types/document";
import { canCiteDocument } from "../../components/modals/updateDocumentModal";
import { ReferenceSubmissionTypes } from "../../_enums/referenceSubmissionTypes.enum";
import parsePhoneNumberFromString from "libphonenumber-js";
import type { HealthDeclarationConfig } from "../../_types/healthDeclaration";
import type { CriminalRecordDeclarationConfig } from "../../_types/criminalRecordDeclaration";
import { getCustomQuestionAnswerMap, type CustomQuestionValidationOptions, validateCustomQuestionAnswers } from "../../components/ui/forms/question-config/lib";

export const GetValidationErrorMessages = (errors: Array<{ error?: unknown }>): string[] =>
	Array.from(
		new Set(
			errors.flatMap(({ error }) => {
				if (typeof error === "string") return [error];
				if (!error || typeof error !== "object" || Array.isArray(error)) return [];
				return Object.values(error).filter((message): message is string => typeof message === "string");
			})
		)
	);

export const IsEmail = (val) => {
	const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
	if (val) {
		if (reg.exec(val)) {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
};

export const IsProfessionalEmail = (val) => {
	const reg = /^[A-Za-z0-9.'_%+-]+@(?!(?:gmail|yahoo|hotmail|outlook|live|msn|icloud)\.(?:com|co\.uk)$)[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/i;
	if (val) {
		if (reg.exec(val)) {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
};

export const IsTelephone = (val) => {
	return true;
	// const reg = /^([+]?\d{1,2}[-\s]?|)\d{3}[-\s]?\d{3}[-\s]?\d{4}$/i;
	// if (val) {
	// 	if (reg.exec(val)) {
	// 		return true;
	// 	} else {
	// 		return false;
	// 	}
	// } else {
	// 	return false;
	// }
};

export const IsWebSite = (val) => {
	const reg = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.){1,}[a-zA-Z]{2,}(\/[^\s]*)?$/i;
	if (val) {
		if (reg.exec(val)) {
			return true;
		} else {
			return false;
		}
	} else {
		return false;
	}
};

export const isInvalidPhoneNumber = (number: string) => {
	const parsedNumber = parsePhoneNumberFromString(number?.trim(), "GB");

	return !parsedNumber?.isValid();
};

export const ValidateLogin = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.username) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "usernameError",
				error: "Username is required.",
			})
		);
	}
	if (!DATA.password) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "passwordError",
				error: "Password is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateCode = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.code) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "codeError",
				error: "Your 2 Factor code is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateReset1 = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.email) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "emailError",
				error: "Email is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateReset2 = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.password) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "passwordError",
				error: "Password is required.",
			})
		);
	} else {
		if (DATA.password.length < 8) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "passwordError",
					error: "Password must be at least 8 characters.",
				})
			);
		}
	}
	if (!DATA.confirmPassword) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "confirmPasswordError",
				error: "You must confirm your password.",
			})
		);
	}
	if (DATA.password && DATA.confirmPassword && DATA.password !== DATA.confirmPassword) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "confirmPasswordError",
				error: "You must confirm your password.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateRegister = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.email) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "emailError",
				error: "Email is required.",
			})
		);
	}
	if (DATA.email && !IsEmail(DATA.email)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "emailError",
				error: "Please enter a valid email address.",
			})
		);
	}
	if (!DATA.username) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "usernameError",
				error: "Username is required.",
			})
		);
	}
	if (!DATA.password) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "passwordError",
				error: "Password is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateRegisterForUpdates = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.email) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "emailError",
				error: "Please enter your email.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateClient = (DATA: ClientInterface) => {
	let valid = true,
		errors = [];
	if (!DATA.name) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "nameError",
				error: "Client name is required.",
			})
		);
	}
	if (DATA.email && !IsEmail(DATA.email)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "emailError",
				error: "Please enter a valid email address.",
			})
		);
	}
	if (DATA.website && !IsWebSite(DATA.website)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "websiteError",
				error: "Please enter a valid website url.",
			})
		);
	}
	if (!DATA.address) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "addressLine1Error",
				error: "Address Line 1 is required.",
			})
		);
		errors.push(
			new FieldValidaionModel({
				name: "postcodeError",
				error: "Postcode is required.",
			})
		);
	} else {
		if (!DATA.address.addressLine1) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "addressLine1Error",
					error: "Address Line 1 is required.",
				})
			);
		}
		if (!DATA.address.postcode) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "postcodeError",
					error: "Postcode is required.",
				})
			);
		}
	}
	if (DATA.additionalInstructions) {
		if (DATA.additionalInstructions.length > 500) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "additionalInstructionsError",
					error: "Additional instructions must be less than 500 characters.",
				})
			);
		}
	}
	if (DATA.additionalInstructionsClient) {
		if (DATA.additionalInstructionsClient.length > 500) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "additionalInstructionsClientError",
					error: "Additional instructions must be less than 500 characters.",
				})
			);
		}
	}
	if (DATA.telephone && isInvalidPhoneNumber(DATA.telephone)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "telephoneError",
				error: "Please enter a valid phone number.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateClients = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.clients || !DATA.clients.length) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "clientsError",
				error: "Make sure a valid clients CSV has been uploaded.",
			})
		);
	}
	if (DATA.clients && DATA.clients.length) {
		let valid = true;
		for (let i = 0, item; (item = DATA.clients[i++]); ) {
			if (!item.name || !item.addressLine1 || !item.postcode) valid = false;
		}
		if (!valid) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "clientsError",
					error: "Make sure all clients have at least a name, address line 1 and postcode.",
				})
			);
		}
	}
	return { valid, errors };
};

export const ValidateClientContactsForUpload = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.contacts || !DATA.contacts.length) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "contactsError",
				error: "Make sure a valid client contacts CSV has been uploaded.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateCandidates = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.candidates || !DATA.candidates.length) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "candidatesError",
				error: "Make sure a valid candidates CSV has been uploaded.",
			})
		);
	}
	if (DATA.candidates && DATA.candidates.length) {
		let valid = true;
		for (let i = 0, item; (item = DATA.candidates[i++]); ) {
			if (!item.forename || !item.surname) valid = false;
		}
		if (!valid) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "candidatesError",
					error: "Make sure all candidates have at least a forename and surname.",
				})
			);
		}
	}
	return { valid, errors };
};

export const ValidateContact = (DATA: ContactInterface) => {
	let valid = true,
		errors = [];
	if (!DATA.forename || !DATA.forename.trim()) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "forenameError",
				error: "First name is required.",
			})
		);
	}
	// if (!DATA.email || !DATA.email.trim()) {
	// 	valid = false;
	// 	errors.push(
	// 		new FieldValidaionModel({
	// 			name: "emailError",
	// 			error: "Email is required.",
	// 		})
	// 	);
	// }
	if (DATA.email && !IsEmail(DATA.email)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "emailError",
				error: "Please enter a valid email address.",
			})
		);
	}

	if (DATA.telephone && isInvalidPhoneNumber(DATA.telephone)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "telephoneError",
				error: "Please enter a valid phone number.",
			})
		);
	}
	if (DATA.mobile && isInvalidPhoneNumber(DATA.mobile)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "mobileError",
				error: "Please enter a valid mobile phone number.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateQualification = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.type) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "typeError",
				error: "Qualification Type is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateEmployment = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.employerName) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "employerNameError",
				error: "Employer Name is required.",
			})
		);
	}
	if (!DATA.dateStarted) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "dateStartedError",
				error: "Started Date is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidatePreviousAgency = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.agencyName) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "agencyNameError",
				error: "Agency name is required",
			})
		);
	}
	if (!DATA.dateStarted) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "dateStartedError",
				error: "Start date is required",
			})
		);
	}
	return { valid, errors };
};

export const ValidatePreviousAddress = (DATA: IPreviousAddress) => {
	let valid = true,
		errors = [];
	if (!DATA.addressLine1) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "addressLine1Error",
				error: "Address line 1 is required",
			})
		);
	}
	if (!DATA.postcode) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "postcodeError",
				error: "Postcode is required",
			})
		);
	}
	if (!DATA.dateStarted) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "dateStartedError",
				error: "Start date is required",
			})
		);
	} else {
		const dateStarted = moment(DATA.dateStarted, ["YYYY-MM-DD", "DD/MM/YYYY", "MM/DD/YYYY", "YYYY/MM/DD", "DD-MM-YYYY", "DD.MM.YYYY", "YYYY.MM.DD"]);
		if (dateStarted.isValid()) {
			if (dateStarted.isAfter(moment())) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "dateStartedError",
						error: "Start date cannot be in the future",
					})
				);
			}
		}
	}
	return { valid, errors };
};

export const ValidateReferences = (DATA, formQuestions: IFormQuestion[]) => {
	let valid = true,
		errors = [];
	if (!DATA.referenceForename) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "referenceForenameError",
				error: "Reference First Name is required.",
			})
		);
	}
	if (!DATA.referenceSurname) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "referenceSurnameError",
				error: "Reference Surname is required.",
			})
		);
	}
	if (!DATA.referenceEmail) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "referenceEmailError",
				error: "Reference Email is required.",
			})
		);
	}
	if (DATA.referenceEmail && !IsEmail(DATA.referenceEmail)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "referenceEmailError",
				error: "Please enter a valid email address.",
			})
		);
	}
	if (
		ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.referencePreventGenericEmail) &&
		(DATA.referenceType == ReferenceTypes.Employment ||
			DATA.referenceType == ReferenceTypes.Academic ||
			DATA.referenceType == ReferenceTypes.Education ||
			DATA.referenceType == ReferenceTypes.Character ||
			DATA.referenceType == ReferenceTypes.Factual) &&
		DATA.referenceEmail &&
		IsEmail(DATA.referenceEmail)
	) {
		if (!IsProfessionalEmail(DATA.referenceEmail)) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "referenceEmailError",
					error: "A professional referee email address is required for this reference type.",
				})
			);
		}
	}
	if (!ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.onboardingReferenceOptionalTelephone)) {
		if (!DATA.referenceTelephone) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "referenceTelephoneError",
					error: "Reference Telephone is required.",
				})
			);
		}
		if (DATA.referenceTelephone && !IsTelephone(DATA.referenceTelephone)) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "referenceTelephoneError",
					error: "Please enter a valid telephone number.",
				})
			);
		}
	}
	if (!DATA.referenceType) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "referenceTypeError",
				error: "Reference Type is required.",
			})
		);
	}
	if (DATA.referenceType) {
		if (DATA.referenceType == ReferenceTypes.Character) {
			if (!DATA.referenceDuration) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "referenceDurationError",
						error: "Duration is required.",
					})
				);
			}
		}
	}
	return { valid, errors };
};

export const ValidateCandidateCreate = (DATA, formQuestions: IFormQuestion[], healthDeclarationConfig?: HealthDeclarationConfig, criminalRecordConfig?: CriminalRecordDeclarationConfig) => {
	let valid = true,
		errors = [];
	if (!DATA.forename) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "forenameError",
				error: "Candidate first name is required.",
			})
		);
	}
	if (!DATA.surname) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "surnameError",
				error: "Candidate surname is required.",
			})
		);
	}
	if (!DATA.email) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "emailError",
				error: "Candidate email is required.",
			})
		);
	} else {
		if (!IsEmail(DATA.email)) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "emailError",
					error: "Please enter a valid email address.",
				})
			);
		}
	}
	if (!DATA.status) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "statusError",
				error: "Candidate status is required.",
			})
		);
	}

	if (DATA.mobile && isInvalidPhoneNumber(DATA.mobile)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "mobileError",
				error: "Please enter a valid mobile phone number.",
			})
		);
	}
	if (DATA.telephone && isInvalidPhoneNumber(DATA.telephone)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "telephoneError",
				error: "Please enter a valid home phone number.",
			})
		);
	}
	if (DATA.nextOfKin?.nextOfKinTelephone && isInvalidPhoneNumber(DATA.nextOfKin.nextOfKinTelephone)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "nextOfKinTelephoneError",
				error: "Please enter a valid next of kin phone number.",
			})
		);
	}
	if (DATA.nextOfKin?.nextOfKinEmail && !IsEmail(DATA.nextOfKin.nextOfKinEmail)) {
		errors.push(
			new FieldValidaionModel({
				name: "nextOfKinEmailError",
				error: "Please enter a valid email address.",
			})
		);
	}
	if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.candidateSourceRequired)) {
		if (!DATA.source) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "sourceError",
					error: "Candidate source is required.",
				})
			);
		}
	}
	if (healthDeclarationConfig) {
		validateHealthRecord(DATA, errors, formQuestions, undefined, healthDeclarationConfig, { enforceRequired: false });
	}
	if (criminalRecordConfig) {
		validateCriminalRecordDeclaration(DATA, errors, criminalRecordConfig, { enforceRequired: false });
	}
	valid = valid && errors.length === 0;
	return { valid, errors };
};

export const ValidateStudentCreate = (DATA: IStudent) => {
	let valid = true,
		errors = [];
	if (!DATA.forename) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "forenameError",
				error: "Student first name is required.",
			})
		);
	}
	if (!DATA.surname) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "surnameError",
				error: "Student surname is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateCandidateStatusChange = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.status) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "statusError",
				error: "Candidate status is required.",
			})
		);
	}
	return { valid, errors };
};

type ValidationConfigItem = {
	field: string;
	errorName: string;
	message: string;
	requiredIf?: () => boolean;
	validate?: (value: any) => string | null;
};

/** Checks if value is an explicit boolean value of 'false' rather than falsy. Useful as toggle input value can be false, but they have been filled out */
const notExplicitBooleanFalse = (value) => value !== false;

const validateContactInformation = (DATA, errors: FieldValidaionModel[], formQuestions: IFormQuestion[], requiredFields?: RequiredOnboardingFieldConfiguration) => {
	const config: ValidationConfigItem[] = [
		{
			field: "forename",
			errorName: "forenameError",
			message: "First name is required.",
			requiredIf: () => true,
		},
		{
			field: "surname",
			errorName: "surnameError",
			message: "Surname is required.",
			requiredIf: () => true,
		},
		{
			field: "email",
			errorName: "emailError",
			message: "Email is required.",
			requiredIf: () => true,
			validate: (value) => (value && !IsEmail(value) ? "Please enter a valid email address." : null),
		},
		{
			field: "previousNames",
			errorName: "previousNamesError",
			message: "Previous Names is required.",
			requiredIf: () => !!requiredFields?.previousNames,
		},
		{
			field: "otherNames",
			errorName: "otherNamesError",
			message: "Other Names is required.",
			requiredIf: () => !!requiredFields?.otherNames && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.OtherNames),
		},
		{
			field: "dob",
			errorName: "dobError",
			message: "Date of birth is required.",
			requiredIf: () => !!requiredFields?.dob,
			validate: (value) => {
				const dob = moment(value, ["YYYY-MM-DD", "DD/MM/YYYY", "MM/DD/YYYY", "YYYY/MM/DD", "DD-MM-YYYY", "DD.MM.YYYY", "YYYY.MM.DD"]);
				const check18 = ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.onboardingDob18);
				if (dob.isValid() && check18 && moment().diff(dob, "years") < 18) {
					return "A valid age of at least 18 years is required.";
				}
				return null;
			},
		},
		{
			field: "sex",
			errorName: "sexError",
			message: "Gender is required.",
			requiredIf: () => !!requiredFields?.sex,
		},
		{
			field: "occupation",
			errorName: "occupationError",
			message: "Occupation is required.",
			requiredIf: () => !!requiredFields?.occupation,
		},
		{
			field: "subject",
			errorName: "subjectError",
			message: "Specialism is required.",
			requiredIf: () => !!requiredFields?.subject || DATA.occupation === OccupationTypes.Teacher,
		},
		{
			field: "onlineCheckConsent",
			errorName: "onlineCheckConsentError",
			message: "Consent to online check response is required.",
			requiredIf: () => !!requiredFields?.onlineCheckConsent && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.onlineCheckConsent),
		},
		{
			field: "title",
			errorName: "titleError",
			message: "Title is required.",
			requiredIf: () => !!requiredFields?.title && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.candidateTitle),
		},
		{
			field: "mobile",
			errorName: "mobileError",
			message: "Contact mobile number is required.",
			requiredIf: () => !!requiredFields?.mobile || ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.onboardingNumberRequired),
			validate: (value) => (value && isInvalidPhoneNumber(value) ? "Please enter a valid phone number." : null),
		},
		{
			field: "telephone",
			errorName: "telephoneError",
			message: "Telephone is required.",
			requiredIf: () => !!requiredFields?.telephone,
			validate: (value) => (value && isInvalidPhoneNumber(value) ? "Please enter a valid phone number." : null),
		},
		{
			field: "pronoun",
			errorName: "pronounError",
			message: "Preferred pronoun is required.",
			requiredIf: () => !!requiredFields?.pronoun && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.candidatePronoun),
		},
		{
			field: "desiredLocationMultiple",
			errorName: "desiredLocationMultipleError",
			message: "At least one desired location is required.",
			requiredIf: () => !!requiredFields?.desiredLocationMultiple && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.DesiredLocationMultiple),
		},
		{
			field: "desiredLocation",
			errorName: "desiredLocationError",
			message: "Desired location is required.",
			requiredIf: () => !!requiredFields?.desiredLocation,
		},
		{
			field: "trnNumber",
			errorName: "trnNumberError",
			message: "TRN Number is required.",
			requiredIf: () => !!requiredFields?.trnNumber && shouldShowTrnField(DATA?.occupation, formQuestions),
		},
		{
			field: "teacherPayScale",
			errorName: "teacherPayScaleError",
			message: "Teacher pay scale is required.",
			requiredIf: () => !!requiredFields?.teacherPayScale && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.onboardingTeacherPayScaleInput),
		},
		{
			field: "transport",
			errorName: "transportError",
			message: "Transport method is required.",
			requiredIf: () => !!requiredFields?.transport && !IsNonUk(formQuestions),
		},
		{
			field: "homeOfficeShareCode",
			errorName: "homeOfficeShareCodeError",
			message: "Home Office share code is required.",
			requiredIf: () => !!requiredFields?.homeOfficeShareCode && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.homeOfficeShareCode),
		},
		{
			field: "ewcConfirmation",
			errorName: "ewcConfirmationError",
			message: "EWC Confirmation is required.",
			requiredIf: () => !!requiredFields?.ewcConfirmation && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.bookingConfirmationEwcConfirmation),
		},
		{
			field: "subsidiarySubject",
			errorName: "subsidiarySubjectError",
			message: "Subsidiary subject is required.",
			requiredIf: () => !!requiredFields?.subsidiarySubject && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.SubsidiarySubject),
		},
		{
			field: "employmentPreference",
			errorName: "employmentPreferenceError",
			message: "Employment preference is required.",
			requiredIf: () => !!requiredFields?.employmentPreference && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.EmploymentPreference),
		},
	];

	for (const item of config) {
		const value = DATA[item.field];
		const required = item.requiredIf && item.requiredIf();

		if (required && notExplicitBooleanFalse(value) && (!value || (Array.isArray(value) && value.length === 0) || (typeof value === "string" && !!!value.trim()))) {
			errors.push(new FieldValidaionModel({ name: item.errorName, error: item.message }));
			continue;
		}
		if (item.validate) {
			const validationError = item.validate(value);
			if (validationError) {
				errors.push(new FieldValidaionModel({ name: item.errorName, error: validationError }));
			}
		}
	}
};

const validateAddress = (DATA, errors: FieldValidaionModel[], formQuestions: IFormQuestion[], requiredFields?: RequiredOnboardingFieldConfiguration) => {
	const isNonUk = IsNonUk(formQuestions);

	const config: ValidationConfigItem[] = [
		{
			field: "country",
			errorName: "countryError",
			message: "Country is required.",
			requiredIf: () => !!isNonUk && !!requiredFields.address,
		},
		{
			field: "addressLine1",
			errorName: "addressLine1Error",
			message: "Address Line 1 is required.",
			requiredIf: () => !!!isNonUk && !!requiredFields.address,
		},
		{
			field: "postcode",
			errorName: "postcodeError",
			message: "Postcode is required.",
			requiredIf: () => !!!isNonUk && !!requiredFields.address,
		},
	];

	for (const item of config) {
		const required = item.requiredIf?.();
		const value = DATA.address[item.field];

		if (required && (!value || (Array.isArray(value) && value.length === 0))) {
			errors.push(
				new FieldValidaionModel({
					name: item.errorName,
					error: item.message,
				})
			);
			continue;
		}

		if (item.validate) {
			const validationError = item.validate(value);
			if (validationError) {
				errors.push(
					new FieldValidaionModel({
						name: item.errorName,
						error: validationError,
					})
				);
			}
		}
	}
};

const validateNextOfKin = (DATA, errors: FieldValidaionModel[], requiredFields?: RequiredOnboardingFieldConfiguration) => {
	const nextOfKinRequired = !!requiredFields?.nextOfKin;
	const nextOfKin = DATA.nextOfKin;

	if (nextOfKinRequired && !nextOfKin) {
		errors.push(
			new FieldValidaionModel({
				name: "nextOfKinNameError",
				error: "Emergency contact name is required.",
			})
		);

		return;
	}

	if (!nextOfKin) return;

	if (nextOfKinRequired && !nextOfKin.nextOfKinName) {
		errors.push(
			new FieldValidaionModel({
				name: "nextOfKinNameError",
				error: "Emergency contact name is required.",
			})
		);
	}

	const hasTelephone = !!nextOfKin.nextOfKinTelephone;
	const hasEmail = !!nextOfKin.nextOfKinEmail;

	// Only require a phone number when next of kin is mandatory
	if (nextOfKinRequired && !hasTelephone) {
		errors.push(
			new FieldValidaionModel({
				name: "nextOfKinTelephoneError",
				error: "Emergency contact details are required.",
			})
		);
	}

	// Always validate phone format if supplied
	if (hasTelephone && isInvalidPhoneNumber(nextOfKin.nextOfKinTelephone)) {
		errors.push(
			new FieldValidaionModel({
				name: "nextOfKinTelephoneError",
				error: "Please enter a valid telephone number.",
			})
		);
	}

	// Always validate email format if supplied
	if (hasEmail && !IsEmail(nextOfKin.nextOfKinEmail)) {
		errors.push(
			new FieldValidaionModel({
				name: "nextOfKinEmailError",
				error: "Please enter a valid email address.",
			})
		);
	}
};

const validateReferences = (DATA, errors: FieldValidaionModel[], formQuestions: IFormQuestion[], requiredFields?: RequiredOnboardingFieldConfiguration) => {
	if (!requiredFields.references) return;

	const NUM_REFERENCES_REQUIRED = ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.onboardingSingleReference) ? 1 : 2;
	if (!DATA.references || DATA.references.length < NUM_REFERENCES_REQUIRED) {
		errors.push(
			new FieldValidaionModel({
				name: "referencesError",
				error: `At least ${NUM_REFERENCES_REQUIRED} reference${NUM_REFERENCES_REQUIRED > 1 ? "s" : ""} is required.`,
			})
		);
	}

	if (!DATA.referenceCheckConsentName) {
		errors.push(
			new FieldValidaionModel({
				name: "referenceCheckConsentNameError",
				error: "Signature is required.",
			})
		);
	}
	if (!DATA.candidateSignatures?.referenceCheckConsentSignature) {
		errors.push(
			new FieldValidaionModel({
				name: "referenceCheckConsentSignatureError",
				error: "Signature is required.",
			})
		);
	}
};

const validateCriminalRecord = (DATA, errors: FieldValidaionModel[], formQuestions: IFormQuestion[], requiredFields?: RequiredOnboardingFieldConfiguration) => {
	if (!requiredFields.criminalRecord) return;

	if (!DATA.criminalRecord) {
		errors.push(
			new FieldValidaionModel({
				name: "dbsHeldError",
				error: "DBS held is required.",
			})
		);
		if (!IsNonUk(formQuestions)) {
			errors.push(
				new FieldValidaionModel({
					name: "dbsLastCheckedError",
					error: "DBS certificate issue date is required.",
				})
			);
		}
		errors.push(
			new FieldValidaionModel({
				name: "convictedOffenceError",
				error: "Criminal offences is required.",
			})
		);
		errors.push(
			new FieldValidaionModel({
				name: "convictionsError",
				error: "Criminal convictions is required.",
			})
		);
		errors.push(
			new FieldValidaionModel({
				name: "abroadError",
				error: "Have you been abroad response is required.",
			})
		);
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.educationalDisciplinaryProceedings)) {
			errors.push(
				new FieldValidaionModel({
					name: "educationalDisciplinaryProceedingsError",
					error: "Educational disciplinary proceedings response required.",
				})
			);
		}
	} else {
		if (DATA.criminalRecord.dbsHeld === null || DATA.criminalRecord.dbsHeld === undefined) {
			errors.push(
				new FieldValidaionModel({
					name: "dbsHeldError",
					error: "DBS held is required.",
				})
			);
		}
		if (!IsNonUk(formQuestions)) {
			if (DATA.criminalRecord.dbsHeld && !DATA.criminalRecord.dbsNumber) {
				errors.push(
					new FieldValidaionModel({
						name: "dbsNumberError",
						error: "DBS number is required.",
					})
				);
			}
			if (DATA.criminalRecord.dbsHeld) {
				if (!DATA.criminalRecord.dbsLastChecked && !DATA.criminalRecord.dbsUpdateServiceNumber) {
					errors.push(
						new FieldValidaionModel({
							name: "dbsLastCheckedError",
							error: "DBS certificate issue date or update service number is required.",
						})
					);
					errors.push(
						new FieldValidaionModel({
							name: "dbsUpdateServiceNumberError",
							error: "DBS certificate issue date or update service number is required.",
						})
					);
				}
				if (DATA.criminalRecord?.registeredToUpdateService === null || DATA.criminalRecord?.registeredToUpdateService === undefined) {
					errors.push(
						new FieldValidaionModel({
							name: "registeredToUpdateServiceError",
							error: "Is the DBS record registered to the update service is required.",
						})
					);
				}
				if (DATA.criminalRecord?.registeredToUpdateService && (DATA.criminalRecord?.consentUpdateServiceChecks === null || DATA.criminalRecord?.consentUpdateServiceChecks === undefined)) {
					errors.push(
						new FieldValidaionModel({
							name: "consentUpdateServiceChecksError",
							error: "Update service consent response is required.",
						})
					);
				}
			}
		}
		// Skip signature validation for legacy candidates who completed criminal record before e-signature feature
		// Legacy candidates have criminalRecordCheckConsent = true but no signature
		const isLegacyCriminalRecordConsent = DATA.criminalRecordCheckConsent === true && !DATA.candidateSignatures?.criminalRecordCheckConsentSignature;

		if (!isLegacyCriminalRecordConsent) {
			if (!DATA.criminalRecordCheckConsentName) {
				errors.push(
					new FieldValidaionModel({
						name: "criminalRecordCheckConsentNameError",
						error: "Signature is required.",
					})
				);
			}
			if (!DATA.candidateSignatures?.criminalRecordCheckConsentSignature) {
				errors.push(
					new FieldValidaionModel({
						name: "criminalRecordCheckConsentSignatureError",
						error: "Signature is required.",
					})
				);
			}
		}
		if (DATA.criminalRecord.convictedOffence === null || DATA.criminalRecord.convictedOffence === undefined) {
			errors.push(
				new FieldValidaionModel({
					name: "convictedOffenceError",
					error: "Criminal offences is required.",
				})
			);
		}
		if (DATA.criminalRecord.convictions === null || DATA.criminalRecord.convictions === undefined) {
			errors.push(
				new FieldValidaionModel({
					name: "convictionsError",
					error: "Criminal convictions is required.",
				})
			);
		}
		if (DATA.criminalRecord.convictions && !DATA.criminalRecord.convictionsDescription) {
			errors.push(
				new FieldValidaionModel({
					name: "convictionsDescriptionError",
					error: "Details of past criminal convictions is required.",
				})
			);
		}
		if (DATA.criminalRecord.convictedOffence && !DATA.criminalRecord.convictedOffenceDescription) {
			errors.push(
				new FieldValidaionModel({
					name: "convictedOffenceDescriptionError",
					error: "Details of criminal offence is required.",
				})
			);
		}
		if (DATA.criminalRecord.abroad === null || DATA.criminalRecord.abroad === undefined) {
			errors.push(
				new FieldValidaionModel({
					name: "abroadError",
					error: "Have you been abroad response is required.",
				})
			);
		}
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.educationalDisciplinaryProceedings)) {
			if (DATA.criminalRecord.educationalDisciplinaryProceedings === null || DATA.criminalRecord.educationalDisciplinaryProceedings === undefined) {
				errors.push(
					new FieldValidaionModel({
						name: "educationalDisciplinaryProceedingsError",
						error: "Educational disciplinary proceedings response required.",
					})
				);
			}
		}
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.onboardingOverseasOffence)) {
			if (DATA.criminalRecord.overseasOffence === null || DATA.criminalRecord.overseasOffence === undefined) {
				errors.push(
					new FieldValidaionModel({
						name: "overseasOffenceError",
						error: "Have you committed an offence overseas which would have resulted in disqualification response is required.",
					})
				);
			}
			if (DATA.criminalRecord?.overseasOffence && !DATA.criminalRecord?.overseasOffenceDescription) {
				errors.push(
					new FieldValidaionModel({
						name: "overseasOffenceDescriptionError",
						error: "Further information related to the offence overseas is required.",
					})
				);
			}
		}
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.currentCriminalOffence)) {
			if (DATA.criminalRecord?.currentCriminalOffence === null || DATA.criminalRecord?.currentCriminalOffence === undefined) {
				errors.push(
					new FieldValidaionModel({
						name: "currentCriminalOffenceError",
						error: "Are you currently under investigation for any criminal offence response is required.",
					})
				);
			}
			if (DATA.criminalRecord?.currentCriminalOffence && !DATA.criminalRecord?.currentCriminalOffenceDescription) {
				errors.push(
					new FieldValidaionModel({
						name: "currentCriminalOffenceDescriptionError",
						error: "Further information related to the current offence is required.",
					})
				);
			}
		}
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.overseasDeclarationExtended) && DATA.criminalRecord.abroad) {
			if (!DATA.criminalRecord.overseasDeclarationExtended) {
				errors.push(
					new FieldValidaionModel({
						name: "overseasDeclarationExtendedError",
						error: "Please declare the country you resided and any additional useful information.",
					})
				);
			}
		}
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.dbsDeclarationRead)) {
			if (DATA.criminalRecord.dbsDeclarationRead === null || DATA.criminalRecord.dbsDeclarationRead === undefined) {
				errors.push(
					new FieldValidaionModel({
						name: "dbsDeclarationReadError",
						error: "Please declare your read status for the Standard/Enhanced DBS Check Privacy Policy.",
					})
				);
			}
		}
	}
};

const validateCriminalRecordDeclaration = (DATA, errors: FieldValidaionModel[], config: CriminalRecordDeclarationConfig, validationOptions?: CustomQuestionValidationOptions) => {
	const answerMap = getCustomQuestionAnswerMap(DATA.criminalRecordDeclaration?.answers, config.questions);
	const answerErrors = validateCustomQuestionAnswers(config.questions, answerMap, validationOptions);
	if (answerMap.dbsHeld === true) {
		const evidenceKeys = ["dbsLastChecked", "dbsUpdateServiceNumber"].filter((key) => config.questions.some((question) => question.enabled && question.key === key));
		if (evidenceKeys.length > 0 && !evidenceKeys.some((key) => typeof answerMap[key] === "string" && String(answerMap[key]).trim())) {
			for (const key of evidenceKeys) answerErrors[key] = "DBS certificate issue date or update service number is required.";
		}
	}
	if (Object.keys(answerErrors).length) {
		errors.push(new FieldValidaionModel({ name: "criminalRecordDeclarationAnswerError", error: answerErrors }));
	}
};

const validateSafeInEducation = (DATA, errors: FieldValidaionModel[], formQuestions: IFormQuestion[], requiredFields?: RequiredOnboardingFieldConfiguration) => {
	if (!requiredFields.safeInEducation) return;

	if (!DATA.safeInEducation) {
		errors.push(
			...[
				new FieldValidaionModel({ name: "barredError", error: "Either yes or no must be selected." }),
				new FieldValidaionModel({ name: "waiverError", error: "Either yes or no must be selected." }),
				new FieldValidaionModel({ name: "ordersYouError", error: "Either yes or no must be selected." }),
				new FieldValidaionModel({ name: "ordersChildError", error: "Either yes or no must be selected." }),
				new FieldValidaionModel({ name: "previousSafeguardingAllegationsError", error: "Either yes or no must be selected." }),
				new FieldValidaionModel({ name: "cautionedError", error: "Either yes or no must be selected." }),
				new FieldValidaionModel({ name: "anotherCountryError", error: "Either yes or no must be selected." }),
			]
		);
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.keepingChildrenSafeExtendedCaution)) {
			errors.push(
				new FieldValidaionModel({
					name: "violentOffenceError",
					error: "Either yes or no must be selected.",
				})
			);
		}
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.keepingChildrenSafeKCSIE)) {
			errors.push(
				new FieldValidaionModel({
					name: "readKCSIEError",
					error: "Either yes or no must be selected.",
				})
			);
		}
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.KeepingChildrenSafeProhibited)) {
			errors.push(
				new FieldValidaionModel({
					name: "prohibitedFromTeachingError",
					error: "Either yes or no must be selected.",
				})
			);
			errors.push(
				new FieldValidaionModel({
					name: "knownPoliceError",
					error: "Either yes or no must be selected.",
				})
			);
			errors.push(
				new FieldValidaionModel({
					name: "prohibitedFromManagementError",
					error: "Either yes or no must be selected.",
				})
			);
			errors.push(
				new FieldValidaionModel({
					name: "criminalOffencesLawError",
					error: "Either yes or no must be selected.",
				})
			);
		}
		errors.push(
			new FieldValidaionModel({
				name: "safeInEducationDetailsError",
				error: "Either yes or no must be selected.",
			})
		);
	} else {
		if (DATA.safeInEducation.barred === null || DATA.safeInEducation.barred === undefined) {
			errors.push(
				new FieldValidaionModel({
					name: "barredError",
					error: "Either yes or no must be selected.",
				})
			);
		}
		if (DATA.safeInEducation.waiver === null || DATA.safeInEducation.waiver === undefined) {
			errors.push(
				new FieldValidaionModel({
					name: "waiverError",
					error: "Either yes or no must be selected.",
				})
			);
		}
		if (DATA.safeInEducation.ordersYou === null || DATA.safeInEducation.ordersYou === undefined) {
			errors.push(
				new FieldValidaionModel({
					name: "ordersYouError",
					error: "Either yes or no must be selected.",
				})
			);
		}
		if (DATA.safeInEducation.ordersChild === null || DATA.safeInEducation.ordersChild === undefined) {
			errors.push(
				new FieldValidaionModel({
					name: "ordersChildError",
					error: "Either yes or no must be selected.",
				})
			);
		}
		if (DATA.safeInEducation.previousSafeguardingAllegations === null || DATA.safeInEducation.previousSafeguardingAllegations === undefined) {
			errors.push(
				new FieldValidaionModel({
					name: "previousSafeguardingAllegationsError",
					error: "Either yes or no must be selected.",
				})
			);
		}
		if (DATA.safeInEducation.cautioned === null || DATA.safeInEducation.cautioned === undefined) {
			errors.push(
				new FieldValidaionModel({
					name: "cautionedError",
					error: "Either yes or no must be selected.",
				})
			);
		}
		if (DATA.safeInEducation.readChildcareAct === null || DATA.safeInEducation.readChildcareAct === undefined) {
			errors.push(
				new FieldValidaionModel({
					name: "readChildcareActError",
					error: "Either yes or no must be selected.",
				})
			);
		}
		if (DATA.safeInEducation.anotherCountry === null || DATA.safeInEducation.anotherCountry === undefined) {
			errors.push(
				new FieldValidaionModel({
					name: "anotherCountryError",
					error: "Either yes or no must be selected.",
				})
			);
		}
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.keepingChildrenSafeExtendedCaution)) {
			if (DATA.safeInEducation.violentOffence === null || DATA.safeInEducation.violentOffence === undefined) {
				errors.push(
					new FieldValidaionModel({
						name: "violentOffenceError",
						error: "Either yes or no must be selected.",
					})
				);
			}
		}
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.keepingChildrenSafeKCSIE)) {
			if (DATA.safeInEducation.readKCSIE === null || DATA.safeInEducation.readKCSIE === undefined) {
				errors.push(
					new FieldValidaionModel({
						name: "readKCSIEError",
						error: "Either yes or no must be selected.",
					})
				);
			}
		}
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.KeepingChildrenSafeProhibited)) {
			if (DATA.safeInEducation.prohibitedFromTeaching === null || DATA.safeInEducation.prohibitedFromTeaching === undefined) {
				errors.push(
					new FieldValidaionModel({
						name: "prohibitedFromTeachingError",
						error: "Either yes or no must be selected.",
					})
				);
			}
			if (DATA.safeInEducation.knownPolice === null || DATA.safeInEducation.knownPolice === undefined) {
				errors.push(
					new FieldValidaionModel({
						name: "knownPoliceError",
						error: "Either yes or no must be selected.",
					})
				);
			}
			if (DATA.safeInEducation.prohibitedFromManagement === null || DATA.safeInEducation.prohibitedFromManagement === undefined) {
				errors.push(
					new FieldValidaionModel({
						name: "prohibitedFromManagementError",
						error: "Either yes or no must be selected.",
					})
				);
			}
			if (DATA.safeInEducation.criminalOffencesLaw === null || DATA.safeInEducation.criminalOffencesLaw === undefined) {
				errors.push(
					new FieldValidaionModel({
						name: "criminalOffencesLawError",
						error: "Either yes or no must be selected.",
					})
				);
			}
		}
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.keepingChildrenSafeExtendedCaution)) {
			if (DATA.safeInEducation.violentOffence && !DATA.safeInEducation.safeInEducationDetails) {
				errors.push(
					new FieldValidaionModel({
						name: "safeInEducationDetailsError",
						error: "Further details are required.",
					})
				);
			}
		}
		if (
			(DATA.safeInEducation.barred ||
				DATA.safeInEducation.waiver ||
				DATA.safeInEducation.ordersYou ||
				DATA.safeInEducation.ordersChild ||
				DATA.safeInEducation.previousSafeguardingAllegations ||
				DATA.safeInEducation.cautioned ||
				DATA.safeInEducation.anotherCountry) &&
			!DATA.safeInEducation.safeInEducationDetails
		) {
			errors.push(
				new FieldValidaionModel({
					name: "safeInEducationDetailsError",
					error: "Further details are required.",
				})
			);
		}
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.KeepingChildrenSafeProhibited)) {
			if (
				(DATA.safeInEducation.prohibitedFromTeaching || DATA.safeInEducation.knownPolice || DATA.safeInEducation.prohibitedFromManagement || DATA.safeInEducation.criminalOffencesLaw) &&
				!DATA.safeInEducation.safeInEducationDetails
			) {
				errors.push(
					new FieldValidaionModel({
						name: "safeInEducationDetailsError",
						error: "Further details are required.",
					})
				);
			}
		}
		if (!DATA.safeInEducationCheckConsentName) {
			errors.push(
				new FieldValidaionModel({
					name: "safeInEducationCheckConsentNameError",
					error: "Signature is required.",
				})
			);
		}
		if (!DATA.candidateSignatures?.safeInEducationCheckConsentSignature) {
			errors.push(
				new FieldValidaionModel({
					name: "safeInEducationCheckConsentSignatureError",
					error: "Signature is required.",
				})
			);
		}
		if (formQuestions?.find((question) => question.type === FormQuestionModuleType.candidate && question.question === FormQuestionType.safeQuardingQuestionaire)) {
			if (
				!DATA?.safeInEducation.safeguardingQuestionaire?.primaryPurposeSafeguarding ||
				DATA?.safeInEducation.safeguardingQuestionaire?.primaryPurposeSafeguarding === null ||
				DATA?.safeInEducation.safeguardingQuestionaire?.primaryPurposeSafeguarding === undefined
			) {
				errors.push(
					new FieldValidaionModel({
						name: "primaryPurposeSafeguardingError",
						error: "Answer must be selected.",
					})
				);
			}
			if (
				!DATA?.safeInEducation.safeguardingQuestionaire?.typicallyResponsibleCoordinatingSafeguarding ||
				DATA?.safeInEducation.safeguardingQuestionaire?.typicallyResponsibleCoordinatingSafeguarding === null ||
				DATA?.safeInEducation.safeguardingQuestionaire?.typicallyResponsibleCoordinatingSafeguarding === undefined
			) {
				errors.push(
					new FieldValidaionModel({
						name: "typicallyResponsibleCoordinatingSafeguardingError",
						error: "Answer must be selected.",
					})
				);
			}
			if (
				!DATA?.safeInEducation.safeguardingQuestionaire?.signOfAbuse ||
				DATA?.safeInEducation.safeguardingQuestionaire?.signOfAbuse === null ||
				DATA?.safeInEducation.safeguardingQuestionaire?.signOfAbuse === undefined
			) {
				errors.push(
					new FieldValidaionModel({
						name: "signOfAbuseError",
						error: "Answer must be selected.",
					})
				);
			}
			if (
				!DATA?.safeInEducation.safeguardingQuestionaire?.studentDisclosesInformation ||
				DATA?.safeInEducation.safeguardingQuestionaire?.studentDisclosesInformation === null ||
				DATA?.safeInEducation.safeguardingQuestionaire?.studentDisclosesInformation === undefined
			) {
				errors.push(
					new FieldValidaionModel({
						name: "studentDisclosesInformationError",
						error: "Answer must be selected.",
					})
				);
			}
			if (
				!DATA?.safeInEducation.safeguardingQuestionaire?.schoolsChildProtectionPolicy ||
				DATA?.safeInEducation.safeguardingQuestionaire?.schoolsChildProtectionPolicy === null ||
				DATA?.safeInEducation.safeguardingQuestionaire?.schoolsChildProtectionPolicy === undefined
			) {
				errors.push(
					new FieldValidaionModel({
						name: "schoolsChildProtectionPolicyError",
						error: "Answer must be selected.",
					})
				);
			}
			if (
				!DATA?.safeInEducation.safeguardingQuestionaire?.fgmDefinition ||
				DATA?.safeInEducation.safeguardingQuestionaire?.fgmDefinition === null ||
				DATA?.safeInEducation.safeguardingQuestionaire?.fgmDefinition === undefined
			) {
				errors.push(
					new FieldValidaionModel({
						name: "fgmDefinitionError",
						error: "Answer must be selected.",
					})
				);
			}
			if (
				!DATA?.safeInEducation.safeguardingQuestionaire?.keyPrincipleOnlineSafetyStudents ||
				DATA?.safeInEducation.safeguardingQuestionaire?.keyPrincipleOnlineSafetyStudents === null ||
				DATA?.safeInEducation.safeguardingQuestionaire?.keyPrincipleOnlineSafetyStudents === undefined
			) {
				errors.push(
					new FieldValidaionModel({
						name: "keyPrincipleOnlineSafetyStudentsError",
						error: "Answer must be selected.",
					})
				);
			}
			if (
				!DATA?.safeInEducation.safeguardingQuestionaire?.teachersConsiderRegardingSafeguarding ||
				DATA?.safeInEducation.safeguardingQuestionaire?.teachersConsiderRegardingSafeguarding === null ||
				DATA?.safeInEducation.safeguardingQuestionaire?.teachersConsiderRegardingSafeguarding === undefined
			) {
				errors.push(
					new FieldValidaionModel({
						name: "teachersConsiderRegardingSafeguardingError",
						error: "Answer must be selected.",
					})
				);
			}
			if (
				!DATA?.safeInEducation.safeguardingQuestionaire?.criminalBackgroundCheckTeachers ||
				DATA?.safeInEducation.safeguardingQuestionaire?.criminalBackgroundCheckTeachers === null ||
				DATA?.safeInEducation.safeguardingQuestionaire?.criminalBackgroundCheckTeachers === undefined
			) {
				errors.push(
					new FieldValidaionModel({
						name: "criminalBackgroundCheckTeachersError",
						error: "Answer must be selected.",
					})
				);
			}
			if (
				!DATA?.safeInEducation.safeguardingQuestionaire?.studentConfides ||
				DATA?.safeInEducation.safeguardingQuestionaire?.studentConfides === null ||
				DATA?.safeInEducation.safeguardingQuestionaire?.studentConfides === undefined
			) {
				errors.push(
					new FieldValidaionModel({
						name: "studentConfidesError",
						error: "Answer must be selected.",
					})
				);
			}
		}
	}
};

const validateHealthRecord = (
	DATA,
	errors: FieldValidaionModel[],
	formQuestions: IFormQuestion[],
	requiredFields?: RequiredOnboardingFieldConfiguration,
	healthDeclarationConfig?: HealthDeclarationConfig,
	validationOptions?: CustomQuestionValidationOptions
) => {
	if (healthDeclarationConfig) {
		const answerErrors = validateCustomQuestionAnswers(
			healthDeclarationConfig.questions,
			getCustomQuestionAnswerMap(DATA.healthDeclaration?.answers, healthDeclarationConfig.questions),
			validationOptions
		);
		if (Object.keys(answerErrors).length) {
			errors.push(new FieldValidaionModel({ name: "healthDeclarationAnswerError", error: answerErrors }));
		}
		return;
	}
	if (!requiredFields.healthRecord) return;

	if (!ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.healthAndDisability)) {
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.healthDeclarationConcise)) {
			if (!DATA.healthRecord) {
				errors.push(
					new FieldValidaionModel({
						name: "healthIssuesError",
						error: "You must complete the health declaration.",
					})
				);
			} else {
				if (
					DATA.healthRecord.affectAbility === null ||
					DATA.healthRecord.affectAbility === undefined ||
					DATA.healthRecord.notificationAgree === null ||
					DATA.healthRecord.notificationAgree === undefined
				) {
					errors.push(
						new FieldValidaionModel({
							name: "healthIssuesError",
							error: "You must provide an answer to each of the above health declaration questions.",
						})
					);
				}
				if ((DATA.healthRecord.affectAbility || DATA.healthRecord.expectantMother) && !DATA.healthRecord.healthIssuesDescription) {
					errors.push(
						new FieldValidaionModel({
							name: "healthIssuesDescriptionError",
							error: "You must provide further details regarding your health declaration answers above.",
						})
					);
				}
			}
		} else {
			if (!DATA.healthRecord) {
				errors.push(
					new FieldValidaionModel({
						name: "healthIssuesError",
						error: "You must complete the health declaration.",
					})
				);
			} else {
				if (
					DATA.healthRecord.physicalAbilityCondition === null ||
					DATA.healthRecord.physicalAbilityCondition === undefined ||
					DATA.healthRecord.confused === null ||
					DATA.healthRecord.confused === undefined ||
					DATA.healthRecord.hearing === null ||
					DATA.healthRecord.hearing === undefined ||
					DATA.healthRecord.eyesight === null ||
					DATA.healthRecord.eyesight === undefined ||
					DATA.healthRecord.depression === null ||
					DATA.healthRecord.depression === undefined ||
					DATA.healthRecord.severePain === null ||
					DATA.healthRecord.severePain === undefined ||
					DATA.healthRecord.excessiveDrowsiness === null ||
					DATA.healthRecord.excessiveDrowsiness === undefined ||
					DATA.healthRecord.epilepsy === null ||
					DATA.healthRecord.epilepsy === undefined ||
					DATA.healthRecord.heart === null ||
					DATA.healthRecord.heart === undefined ||
					DATA.healthRecord.asthma === null ||
					DATA.healthRecord.asthma === undefined ||
					DATA.healthRecord.mentalHealth === null ||
					DATA.healthRecord.mentalHealth === undefined ||
					DATA.healthRecord.allergies === null ||
					DATA.healthRecord.allergies === undefined ||
					(formQuestions?.find((question) => question.type === FormQuestionModuleType.candidate && question.question === FormQuestionType.healthDeclaration) &&
						(DATA.healthRecord.contagiousDiseases === null || DATA.healthRecord.contagiousDiseases === undefined))
				) {
					errors.push(
						new FieldValidaionModel({
							name: "healthIssuesError",
							error: "You must provide an answer to each of the above health declaration questions.",
						})
					);
				}
				if (!ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.onboardingMedicalRequirements)) {
					if (DATA.healthRecord.medication === null || DATA.healthRecord.medication === undefined) {
						errors.push(
							new FieldValidaionModel({
								name: "healthIssuesError",
								error: "You must provide an answer to each of the above health declaration questions.",
							})
						);
					}
				}
				if (
					(DATA.healthRecord.physicalAbilityCondition ||
						DATA.healthRecord.confused ||
						DATA.healthRecord.hearing ||
						DATA.healthRecord.eyesight ||
						DATA.healthRecord.depression ||
						DATA.healthRecord.severePain ||
						DATA.healthRecord.excessiveDrowsiness ||
						DATA.healthRecord.epilepsy ||
						DATA.healthRecord.heart ||
						DATA.healthRecord.asthma ||
						DATA.healthRecord.mentalHealth ||
						DATA.healthRecord.expectantMother ||
						DATA.healthRecord.allergies ||
						DATA.healthRecord.medication ||
						(formQuestions?.find((question) => question.type === FormQuestionModuleType.candidate && question.question === FormQuestionType.healthDeclaration) &&
							DATA.healthRecord.contagiousDiseases)) &&
					!DATA.healthRecord.healthIssuesDescription
				) {
					errors.push(
						new FieldValidaionModel({
							name: "healthIssuesDescriptionError",
							error: "You must provide further details regardling your health declaration answers above.",
						})
					);
				}
			}
		}
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.medicalHealthDeclaration)) {
			if (
				DATA.healthRecord?.vaccinationMeasles === null ||
				DATA.healthRecord?.vaccinationMeasles === undefined ||
				DATA.healthRecord?.vaccinationMumps === null ||
				DATA.healthRecord?.vaccinationMumps === undefined ||
				DATA.healthRecord?.vaccinationRubella === null ||
				DATA.healthRecord?.vaccinationRubella === undefined ||
				DATA.healthRecord?.vaccinationVaricella === null ||
				DATA.healthRecord?.vaccinationVaricella === undefined ||
				DATA.healthRecord?.vaccinationTuberculosis === null ||
				DATA.healthRecord?.vaccinationTuberculosis === undefined ||
				DATA.healthRecord?.vaccinationHepatitisB === null ||
				DATA.healthRecord?.vaccinationHepatitisB === undefined ||
				DATA.healthRecord?.vaccinationHepatitisC === null ||
				DATA.healthRecord?.vaccinationHepatitisC === undefined ||
				DATA.healthRecord?.vaccinationHIV === null ||
				DATA.healthRecord?.vaccinationHIV === undefined ||
				DATA.healthRecord?.vaccinationCovid === null ||
				DATA.healthRecord?.vaccinationCovid === undefined ||
				DATA.healthRecord?.vaccinationCovid1 === null ||
				DATA.healthRecord?.vaccinationCovid1 === undefined ||
				DATA.healthRecord?.vaccinationCovid2 === null ||
				DATA.healthRecord?.vaccinationCovid2 === undefined ||
				DATA.healthRecord?.vaccinationCovidBooster === null ||
				DATA.healthRecord?.vaccinationCovidBooster === undefined ||
				DATA.healthRecord?.vaccinationCovidInfluenza === null ||
				DATA.healthRecord?.vaccinationCovidInfluenza === undefined
			) {
				errors.push(
					new FieldValidaionModel({
						name: "healthIssuesError",
						error: "You must provide an answer to each of the above health declaration questions.",
					})
				);
			}
		}
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.healthDeclarationSignature)) {
			if (!DATA.healthRecordCheckConsentName) {
				errors.push(
					new FieldValidaionModel({
						name: "healthRecordCheckConsentNameError",
						error: "Signature is required.",
					})
				);
			}
			if (!DATA.candidateSignatures?.healthRecordCheckConsentSignature) {
				errors.push(
					new FieldValidaionModel({
						name: "healthRecordCheckConsentSignatureError",
						error: "Signature is required.",
					})
				);
			}
		}
	}
};

const validateBankDetails = (DATA, errors: FieldValidaionModel[], formQuestions: IFormQuestion[], requiredFields?: RequiredOnboardingFieldConfiguration) => {
	if (!requiredFields.bankDetails) return;

	if (!DATA.bankDetails) {
		errors.push(
			new FieldValidaionModel({
				name: "jobOp3Error",
				error: "Either yes or no must be selected.",
			})
		);
	} else {
		const ifPayTypeSelectionRequired = ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.requireCandidatePayTypeSelection) ? true : false;
		if (ifPayTypeSelectionRequired && !DATA.payType) {
			errors.push(
				new FieldValidaionModel({
					name: "payTypeError",
					error: "Pay type is required.",
				})
			);
		}
		if (!ifPayTypeSelectionRequired || (ifPayTypeSelectionRequired && DATA.payType == CandidatePay.Paye)) {
			if (DATA.bankDetails.jobOp1 === null || DATA.bankDetails.jobOp1 === undefined) {
				errors.push(
					new FieldValidaionModel({
						name: "jobOp1Error",
						error: "You need to select only one of the statements.",
					})
				);
			}
			if (DATA.bankDetails.jobOp2 === null || DATA.bankDetails.jobOp2 === undefined) {
				errors.push(
					new FieldValidaionModel({
						name: "jobOp2Error",
						error: "You need to select only one of the statements.",
					})
				);
			}
			if (DATA.bankDetails.jobOp3 === null || DATA.bankDetails.jobOp3 === undefined) {
				errors.push(
					new FieldValidaionModel({
						name: "jobOp3Error",
						error: "You need to select only one of the statements.",
					})
				);
			}
			if (
				(DATA?.bankDetails?.bankAccountName?.trim() || DATA?.bankDetails?.bankName?.trim() || DATA?.bankDetails?.accountNumber?.trim() || DATA?.bankDetails?.sortCode?.trim()) &&
				!ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.simplifiedBankDetails)
			) {
				if (!DATA?.bankDetails?.bankAccountName?.trim()) {
					errors.push(
						new FieldValidaionModel({
							name: "bankAccountNameError",
							error: "Bank account name is required.",
						})
					);
				}
				if (!DATA?.bankDetails?.bankName?.trim()) {
					errors.push(
						new FieldValidaionModel({
							name: "bankNameError",
							error: "Bank name is required.",
						})
					);
				}
				if (!DATA?.bankDetails?.accountNumber?.trim()) {
					errors.push(
						new FieldValidaionModel({
							name: "accountNumberError",
							error: "Account number is required.",
						})
					);
				}
				if (!DATA?.bankDetails?.sortCode?.trim()) {
					errors.push(
						new FieldValidaionModel({
							name: "sortCodeError",
							error: "Account sort code is required.",
						})
					);
				}
			}
			if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.studentLoan)) {
				if (!DATA?.bankDetails?.studentLoan || DATA?.bankDetails?.studentLoan?.studentLoan === null || DATA?.bankDetails?.studentLoan?.studentLoan === undefined) {
					errors.push(
						new FieldValidaionModel({
							name: "studentLoanError",
							error: "Either yes or no must be selected.",
						})
					);
				}
			}
			if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.onboardingBankRequired)) {
				if (!DATA?.bankDetails?.bankAccountName?.trim()) {
					errors.push(
						new FieldValidaionModel({
							name: "bankAccountNameError",
							error: "Bank account name is required.",
						})
					);
				}
				if (!DATA?.bankDetails?.bankName?.trim()) {
					errors.push(
						new FieldValidaionModel({
							name: "bankNameError",
							error: "Bank name is required.",
						})
					);
				}
				if (!DATA?.bankDetails?.accountNumber?.trim()) {
					errors.push(
						new FieldValidaionModel({
							name: "accountNumberError",
							error: "Account number is required.",
						})
					);
				}
				if (!DATA?.bankDetails?.sortCode?.trim()) {
					errors.push(
						new FieldValidaionModel({
							name: "sortCodeError",
							error: "Account sort code is required.",
						})
					);
				}
				if (!DATA?.bankDetails?.niNumber?.trim()) {
					errors.push(
						new FieldValidaionModel({
							name: "niNumberError",
							error: "National Insurance Number is required.",
						})
					);
				}
			}
		}
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.bankDetailsValidate)) {
			if (DATA?.bankDetails?.accountNumber?.trim() && !/^[0-9]{8}$/.test(DATA?.bankDetails?.accountNumber?.trim())) {
				errors.push(
					new FieldValidaionModel({
						name: "accountNumberError",
						error: "Account number must be exactly 8 digits.",
					})
				);
			}
			if (DATA?.bankDetails?.sortCode?.trim() && !/^[0-9]{6}$/.test(DATA?.bankDetails?.sortCode?.trim())) {
				errors.push(
					new FieldValidaionModel({
						name: "sortCodeError",
						error: "Account sort code must be exactly 6 digits.",
					})
				);
			}
		}

		if (DATA?.bankDetails?.niNumber?.trim?.()) {
			if (!validateNI(DATA?.bankDetails?.niNumber)) {
				errors.push(
					new FieldValidaionModel({
						name: "niNumberError",
						error: "National Insurance Number is required. Format: 2 letters, 6 numbers, 1 letter, no spaces (e.g. AB123456C).",
					})
				);
			}
		}
	}
};

const validateDocuments = (DATA, errors: FieldValidaionModel[], RightToWorkAvailableItems: RightToWorkItem[], requiredFields?: RequiredOnboardingFieldConfiguration) => {
	if (!requiredFields.documents) return;

	if (!DATA.documents?.length) {
		const requiredItems = RightToWorkAvailableItems?.filter?.((item) => item.required) || [];

		const passportGroup = [RightToWork.UKPassport, RightToWork.ForeignPassport, RightToWork.EuropeanPassport, RightToWork.BirthCertificate];

		if (requiredItems?.length) {
			// Group the required items
			const passportDocs = requiredItems.filter((item) => passportGroup.includes(item.ID));
			const otherDocs = requiredItems.filter((item) => !passportGroup.includes(item.ID));

			// Build error message
			const errorParts = [];

			if (passportDocs.length) {
				errorParts.push(`One of: ${passportDocs.map((item) => item.Name).join(", ")}`);
			}

			if (otherDocs.length) {
				errorParts.push(otherDocs.map((item) => item.Name).join(", "));
			}

			errors.push(
				new FieldValidaionModel({
					name: "documentsError",
					error: `The following documents are required: ${errorParts.join("; ")}.`,
				})
			);
		}
	} else {
		const requiredItems = RightToWorkAvailableItems?.filter?.((item) => item.required) || [];
		const docTypes = DATA?.documents?.filter?.((doc) => doc.docType)?.map?.((doc) => parseInt(doc.docType)) || [];

		const passportGroup = [RightToWork.UKPassport, RightToWork.ForeignPassport, RightToWork.EuropeanPassport, RightToWork.BirthCertificate];

		// Check if any uploaded document is in passport group
		const hasPassportDoc = docTypes.some((docType) => passportGroup.includes(docType));

		// Filter out passport group docs from required items if one is already uploaded
		const missingDocs = requiredItems.filter((item) => {
			if (hasPassportDoc && passportGroup.includes(item.ID)) {
				return false; // Skip requiring other passport docs
			}
			return !docTypes.includes(item.ID);
		});

		if (missingDocs.length) {
			// Group the missing docs
			const passportDocs = missingDocs.filter((item) => passportGroup.includes(item.ID));
			const otherDocs = missingDocs.filter((item) => !passportGroup.includes(item.ID));

			// Build error message
			const errorParts = [];

			if (passportDocs.length) {
				errorParts.push(`One of: ${passportDocs.map((item) => item.Name).join(", ")}`);
			}

			if (otherDocs.length) {
				errorParts.push(otherDocs.map((item) => item.Name).join(", "));
			}

			errors.push(
				new FieldValidaionModel({
					name: "documentsError",
					error: `The following documents are required: ${errorParts.join("; ")}.`,
				})
			);
		}
	}
};

const validateEmploymentHistory = (DATA, errors: FieldValidaionModel[], formQuestions: IFormQuestion[], requiredFields?: RequiredOnboardingFieldConfiguration) => {
	if (requiredFields.employment || ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.onboardingEmploymentHistoryRequired)) {
		if (!DATA.employment?.length) {
			errors.push(
				new FieldValidaionModel({
					name: "employmentError",
					error: "At least 1 employment history record is required.",
				})
			);
		}
	}
};

const validateExperienceSummary = (DATA, errors: FieldValidaionModel[], requiredFields?: RequiredOnboardingFieldConfiguration) => {
	if (requiredFields.experienceSummary && !DATA.experienceSummary) {
		errors.push(
			new FieldValidaionModel({
				name: "experienceSummaryError",
				error: "Experience summary is required.",
			})
		);
	}
};

const validateProfilePhoto = (DATA, errors: FieldValidaionModel[], formQuestions: IFormQuestion[], requiredFields?: RequiredOnboardingFieldConfiguration) => {
	if (requiredFields.profilePhoto || ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.onboardingProfilePhotoRequired)) {
		if (!DATA.profilePhoto) {
			errors.push(
				new FieldValidaionModel({
					name: "profilePhotoError",
					error: "Profile photo is required.",
				})
			);
		}
	}
};

const validateDeclaration = (DATA, errors: FieldValidaionModel[]) => {
	if (!DATA.declarationCheckConsentName) {
		errors.push(
			new FieldValidaionModel({
				name: "declarationCheckConsentNameError",
				error: "Signature is required.",
			})
		);
	}
	if (!DATA.candidateSignatures?.declarationCheckConsentSignature) {
		errors.push(
			new FieldValidaionModel({
				name: "declarationCheckConsentSignatureError",
				error: "Signature is required.",
			})
		);
	}
};

const validateContractForService = (DATA, errors: FieldValidaionModel[]) => {
	if (!DATA.contractForServiceName) {
		errors.push(
			new FieldValidaionModel({
				name: "contractForServiceNameError",
				error: "Signature is required.",
			})
		);
	}
	if (!DATA.candidateSignatures?.contractForServiceSignature) {
		errors.push(
			new FieldValidaionModel({
				name: "contractForServiceSignatureError",
				error: "Signature is required.",
			})
		);
	}
};

const validatePreviousAddresses = (DATA, errors: FieldValidaionModel[], requiredFields?: RequiredOnboardingFieldConfiguration) => {
	if (!DATA?.previousAddresses?.length && !!requiredFields.previousAddresses) {
		errors.push(
			new FieldValidaionModel({
				name: "previousAddressesError",
				error: "At least 1 address is required.",
			})
		);
	}
};

const validateQualifications = (DATA, errors: FieldValidaionModel[], requiredFields?: RequiredOnboardingFieldConfiguration) => {
	if (!DATA?.qualifications?.length && !!requiredFields.qualifications) {
		errors.push(
			new FieldValidaionModel({
				name: "qualificationsError",
				error: "At least 1 qualification is required.",
			})
		);
	}
};

const validateoptOut48Hours = (DATA, errors: FieldValidaionModel[], requiredFields?: RequiredOnboardingFieldConfiguration) => {
	if (requiredFields?.optOut48Hours && (DATA.optOut48Hours === null || DATA.optOut48Hours === undefined)) {
		errors.push(
			new FieldValidaionModel({
				name: "optOut48HoursError",
				error: "48 Hour Working Time Regulations agreement is required.",
			})
		);
	}
};

export const ValidateCandidateStep = (
	DATA,
	STEP: CandidateConfigOnboardingSteps,
	formQuestions: IFormQuestion[],
	RightToWorkAvailableItems: RightToWorkItem[],
	requiredFields?: RequiredOnboardingFieldConfiguration,
	healthDeclarationConfig?: HealthDeclarationConfig,
	criminalRecordConfig?: CriminalRecordDeclarationConfig
) => {
	let errors = [];
	if (STEP === "contactInformation") {
		validateContactInformation(DATA, errors, formQuestions, requiredFields);
	} else if (STEP === "address") {
		validateAddress(DATA, errors, formQuestions, requiredFields);
	} else if (STEP === "nextOfKin") {
		validateNextOfKin(DATA, errors, requiredFields);
	} else if (STEP === "employmentHistory") {
		validateEmploymentHistory(DATA, errors, formQuestions, requiredFields);
	} else if (STEP === "references") {
		validateReferences(DATA, errors, formQuestions, requiredFields);
	} else if (STEP === "criminalRecord") {
		if (criminalRecordConfig) validateCriminalRecordDeclaration(DATA, errors, criminalRecordConfig);
		else validateCriminalRecord(DATA, errors, formQuestions, requiredFields);
	} else if (STEP === "safeInEducation") {
		validateSafeInEducation(DATA, errors, formQuestions, requiredFields);
	} else if (STEP === "healthRecord") {
		validateHealthRecord(DATA, errors, formQuestions, requiredFields, healthDeclarationConfig);
	} else if (STEP === "bankDetails") {
		validateBankDetails(DATA, errors, formQuestions, requiredFields);
	} else if (STEP === "experienceSummary") {
		validateExperienceSummary(DATA, errors, requiredFields);
	} else if (STEP === "documents") {
		validateDocuments(DATA, errors, RightToWorkAvailableItems, requiredFields);
	} else if (STEP === "profilePhoto") {
		validateProfilePhoto(DATA, errors, formQuestions, requiredFields);
	} else if (STEP === "declaration") {
		validateDeclaration(DATA, errors);
	} else if (STEP === "contractForService") {
		validateContractForService(DATA, errors);
	} else if (STEP === "previousAddresses") {
		validatePreviousAddresses(DATA, errors, requiredFields);
	} else if (STEP === "qualifications") {
		validateQualifications(DATA, errors, requiredFields);
	} else if (STEP === "optOut48Hours") {
		validateoptOut48Hours(DATA, errors, requiredFields);
	}
	return { valid: errors.length === 0, errors } as { valid: boolean; errors: FieldValidaionModel[] };
};

export const ValidateCandidateOnboardingBankDetails = (DATA, formQuestions: IFormQuestion[]) => {
	let valid = true,
		errors = [];

	if (!ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.simplifiedBankDetails)) {
		if (!DATA?.bankDetails?.bankAccountName?.trim()) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "bankAccountNameError",
					error: "Bank account name is required.",
				})
			);
		}
		if (!DATA?.bankDetails?.bankName?.trim()) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "bankNameError",
					error: "Bank name is required.",
				})
			);
		}
		if (!DATA?.bankDetails?.accountNumber?.trim()) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "accountNumberError",
					error: "Account number is required.",
				})
			);
		}
		if (!DATA?.bankDetails?.sortCode?.trim()) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "sortCodeError",
					error: "Account sort code is required.",
				})
			);
		}
	}
	if (!DATA?.bankDetails?.niNumber?.trim()) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "niNumberError",
				error: "National Insurance Number is required.",
			})
		);
	}
	if (DATA?.bankDetails?.jobOp1 === null || DATA?.bankDetails?.jobOp1 === undefined) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "jobOp1Error",
				error: "Either yes or no must be selected.",
			})
		);
	}
	if (DATA?.bankDetails?.jobOp2 === null || DATA?.bankDetails?.jobOp2 === undefined) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "jobOp2Error",
				error: "Either yes or no must be selected.",
			})
		);
	}
	if (DATA?.bankDetails?.jobOp3 === null || DATA?.bankDetails?.jobOp3 === undefined) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "jobOp3Error",
				error: "Either yes or no must be selected.",
			})
		);
	}
	if (formQuestions?.find((question) => question.type === FormQuestionModuleType.candidate && question.question === FormQuestionType.studentLoan)) {
		if (!DATA?.bankDetails?.studentLoan || DATA?.bankDetails?.studentLoan?.studentLoan === null || DATA?.bankDetails?.studentLoan?.studentLoan === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "studentLoanError",
					error: "Either yes or no must be selected.",
				})
			);
		}
	}
	return { valid, errors };
};

export const ValidateReferenceSubmissionCreate = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.name) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "nameError",
				error: "Candidate name is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateReferenceSubmissionStep = (DATA, STEP, formQuestions: IFormQuestion[]) => {
	let valid = true,
		errors = [];
	if (STEP === 2) {
		if (!DATA.name) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "nameError",
					error: "Candidate name is required.",
				})
			);
		}
		if (DATA.referenceType === 1 || DATA.referenceType === 2 || DATA.referenceType === 4) {
			if (!DATA.dateFrom) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "dateFromError",
						error: "Date started is required.",
					})
				);
			}
			if (!DATA.dateTo) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "dateToError",
						error: "Date left is required.",
					})
				);
			}
			if (!DATA.position) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "positionError",
						error: "Position held is required.",
					})
				);
			}
			if (!DATA.relationship) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "relationshipError",
						error: "Relationship to candidate is required.",
					})
				);
			}
		}

		if (DATA.referenceType === 6) {
			if (!DATA.dateFrom) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "dateFromError",
						error: "Date started is required.",
					})
				);
			}
			if (!DATA.dateTo) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "dateToError",
						error: "Date left is required.",
					})
				);
			}
			if (!DATA.position) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "positionError",
						error: "Position(s) held is required.",
					})
				);
			}

			if (!DATA.applicantVolunteerRole) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "applicantVolunteerRoleError",
						error: "Applicant volunteer role is required.",
					})
				);
			}

			if (!DATA.natureOfVolunteerRole) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "natureOfVolunteerRoleError",
						error: "Nature of role is required.",
					})
				);
			}
		}

		if (DATA.referenceType === 3) {
			if (!DATA.durationKnown) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "durationKnownError",
						error: "Duration known is required.",
					})
				);
			}
			if (!DATA.relationship && !ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.alternativeCharacterReferenceProForma)) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "relationshipError",
						error: "Relationship to candidate is required.",
					})
				);
			}
			if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.alternativeCharacterReferenceProForma)) {
				if (!DATA.capacityKnown) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "capacityKnownError",
							error: "Capacity known is required.",
						})
					);
				}
				if (!DATA.honestAndReliable) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "honestAndReliableError",
							error: "Honest and reliable field is required.",
						})
					);
				}
				if (!DATA.wouldYouRecommend) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "wouldYouRecommendError",
							error: "Would you recommend field is required.",
						})
					);
				}
				if (!DATA.relationshipToApplicant) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "relationshipToApplicantError",
							error: "Relationship to applicant is required.",
						})
					);
				}
			}
		}
		if (DATA.referenceType === 2) {
			if (!DATA.subjectAreas) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "subjectAreasError",
						error: "Key responsibilities/duties required.",
					})
				);
			}
			if (DATA.managerialExperience === null || DATA.managerialExperience === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "managerialExperienceError",
						error: "An answer is required.",
					})
				);
			}
		}
		if (DATA.referenceType === 1 || DATA.referenceType === 2 || DATA.referenceType === 6) {
			if (DATA.reEmploy === null || DATA.reEmploy === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "reEmployError",
						error: "An answer is required.",
					})
				);
			}
			if (DATA.reEmploy !== null && DATA.reEmploy !== undefined && !DATA.reEmploy && !DATA.reEmplyDescription) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "reEmployDescriptionError",
						error: "Further details are required.",
					})
				);
			}
		}

		if (DATA.referenceType === 1 && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.vidaReferenceQuestions)) {
			if (DATA.reEmploy !== null && DATA.reEmploy !== undefined && DATA.reEmploy === true && !(DATA.dayToDay || DATA.longTerm || DATA.permanent)) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "reEmployError",
						error: "At least one type must be selected.",
					})
				);
			}
		}

		if (DATA.referenceType === 4) {
			if (!DATA.daysWorked) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "daysWorkedError",
						error: "Approximate no. days worked is required.",
					})
				);
			}
			if (!DATA.reasonsForLeaving) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "reasonsForLeavingError",
						error: "A reason for leaving is required.",
					})
				);
			}
		}
		if (DATA.referenceType == ReferenceTypes.Academic) {
			if (!DATA.dateFrom) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "dateFromError",
						error: "Studieid from is required.",
					})
				);
			}
			if (!DATA.dateTo) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "dateToError",
						error: "Studied to is required.",
					})
				);
			}
			if (!DATA.relationship) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "relationshipError",
						error: "Relationship to candidate is required.",
					})
				);
			}
			if (!DATA.subjectAreas) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "subjectAreasError",
						error: "Subjects studied is required.",
					})
				);
			}
		}
		if (DATA.referenceType === 1 && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.vidaReferenceQuestions)) {
			if (!DATA.finalSalary) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "finalSalaryError",
						error: "Final salary is required.",
					})
				);
			}
			if (!DATA.subjectAreas) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "subjectAreasError",
						error: "Further details are required.",
					})
				);
			}
			if (!DATA.subjectAreas) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "reasonsForLeavingError",
						error: "Further details are required.",
					})
				);
			}
		}
		if (DATA.referenceType === 2 && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.vidaReferenceQuestions)) {
			if (!DATA.finalSalary) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "finalSalaryError",
						error: "Final salary is required.",
					})
				);
			}
		}
	} else if (STEP === 3) {
		if (
			DATA.referenceType === 1 ||
			(DATA.referenceType === 2 && !ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.vidaReferenceQuestions)) ||
			DATA.referenceType === 4
		) {
			if (DATA.disciplinaryUndergoing === null || DATA.disciplinaryUndergoing === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "disciplinaryUndergoingError",
						error: "An answer is required.",
					})
				);
			}
			if (DATA.disciplinaryUndergoing !== null && DATA.disciplinaryUndergoing !== undefined && DATA.disciplinaryUndergoing && !DATA.disciplinaryUndergoingDescription) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "disciplinaryUndergoingDescriptionError",
						error: "Further details are required.",
					})
				);
			}
		}
		if (
			DATA.referenceType === 1 ||
			(DATA.referenceType === 2 && !ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.vidaReferenceQuestions)) ||
			DATA.referenceType === 3 ||
			DATA.referenceType === 4 ||
			DATA.referenceType === 5
		) {
			if (DATA.disciplinaryHistory === null || DATA.disciplinaryHistory === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "disciplinaryHistoryError",
						error: "An answer is required.",
					})
				);
			}
			if (DATA.disciplinaryHistory !== null && DATA.disciplinaryHistory !== undefined && DATA.disciplinaryHistory && !DATA.disciplinaryHistoryDescription) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "disciplinaryHistoryDescriptionError",
						error: "Further details are required.",
					})
				);
			}
			if (DATA.safeguardingConcerns === null || DATA.safeguardingConcerns === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "safeguardingConcernsError",
						error: "An answer is required.",
					})
				);
			}
			if (DATA.safeguardingConcerns !== null && DATA.safeguardingConcerns !== undefined && DATA.safeguardingConcerns && !DATA.safeguardingConcernsDescription) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "safeguardingConcernsDescriptionError",
						error: "Further details are required.",
					})
				);
			}
			if (DATA.rejectionReason === null || DATA.rejectionReason === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "rejectionReasonError",
						error: "An answer is required.",
					})
				);
			}
			if (DATA.rejectionReason !== null && DATA.rejectionReason !== undefined && DATA.rejectionReason && !DATA.rejectionReasonDescription) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "rejectionReasonDescriptionError",
						error: "Further details are required.",
					})
				);
			}
		}

		if (DATA.referenceType === 2 && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.showMedicalReferenceQuestions)) {
			if (DATA.sicknessRecord === null || DATA.sicknessRecord === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "sicknessRecordError",
						error: "An answer is required.",
					})
				);
			}
			if (DATA.sicknessRecord !== null && DATA.sicknessRecord !== undefined && DATA.sicknessRecord && !DATA.sicknessRecordDescription) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "sicknessRecordDescriptionError",
						error: "Further details are required.",
					})
				);
			}
		}
		if ((DATA.referenceType === 2 || DATA.referenceType === 6) && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.vidaReferenceQuestions)) {
			if (!DATA.reasonsForLeaving) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "reasonsForLeavingError",
						error: "Further details are required.",
					})
				);
			}
			if (DATA.honestAndTrustworthy === null || DATA.honestAndTrustworthy === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "honestAndTrustworthyError",
						error: "An answer is required.",
					})
				);
			}
			if (DATA.honestAndTrustworthy !== null && DATA.honestAndTrustworthy !== undefined && !DATA.honestAndTrustworthy && !DATA.honestAndTrustworthyDescription) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "honestAndTrustworthyDescriptionError",
						error: "An answer is required.",
					})
				);
			}
			if (DATA.subjectOfDisciplinaryProcedure === null || DATA.subjectOfDisciplinaryProcedure === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "subjectOfDisciplinaryProcedureError",
						error: "An answer is required.",
					})
				);
			}
			if (
				DATA.subjectOfDisciplinaryProcedure !== null &&
				DATA.subjectOfDisciplinaryProcedure !== undefined &&
				DATA.subjectOfDisciplinaryProcedure &&
				!DATA.subjectOfDisciplinaryProcedureDescription
			) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "subjectOfDisciplinaryProcedureDescriptionError",
						error: "An answer is required.",
					})
				);
			}
		}
		if (DATA.referenceType === 6) {
			if (DATA.subjectOfDisciplinaryAction === null || DATA.subjectOfDisciplinaryAction === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "subjectOfDisciplinaryActionError",
						error: "An answer is required.",
					})
				);
			}
			if (
				DATA.subjectOfDisciplinaryAction !== null &&
				DATA.subjectOfDisciplinaryAction !== undefined &&
				DATA.subjectOfDisciplinaryAction === true &&
				!DATA.subjectOfDisciplinaryActionDescription
			) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "subjectOfDisciplinaryActionDescriptionError",
						error: "An answer is required.",
					})
				);
			}
			if (DATA.safeguardingChildProcedure === null || DATA.safeguardingChildProcedure === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "safeguardingChildProcedureError",
						error: "An answer is required.",
					})
				);
			}
			if (DATA.safeguardingChildProcedure !== null && DATA.safeguardingChildProcedure !== undefined && DATA.safeguardingChildProcedure === true && !DATA.safeguardingChildProcedureDescription) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "safeguardingChildProcedureDescriptionError",
						error: "An answer is required.",
					})
				);
			}
		}
	} else if (STEP === 4) {
		if (DATA.referenceType === 1) {
			if (DATA.manageClassBehaviour === null || DATA.manageClassBehaviour === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "manageClassBehaviourError",
						error: "A grade is required.",
					})
				);
			}
			if (!ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.vidaReferenceQuestions)) {
				if (DATA.profressionalism === null || DATA.profressionalism === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "profressionalismError",
							error: "A grade is required.",
						})
					);
				}
			}
			if (DATA.planning === null || DATA.planning === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "planningError",
						error: "A grade is required.",
					})
				);
			}
			if (DATA.ability === null || DATA.ability === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "abilityError",
						error: "A grade is required.",
					})
				);
			}
			if (DATA.rapport === null || DATA.rapport === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "rapportError",
						error: "A grade is required.",
					})
				);
			}
			if (DATA.agencySuitability === null || DATA.agencySuitability === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "agencySuitabilityError",
						error: "A grade is required.",
					})
				);
			}
			if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.educationReferenceExtended)) {
				if (DATA.subjectKnowledge === null || DATA.subjectKnowledge === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "subjectKnowledgeError",
							error: "A grade is required.",
						})
					);
				}
				if (DATA.peerRelationship === null || DATA.peerRelationship === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "peerRelationshipError",
							error: "A grade is required.",
						})
					);
				}
				if (DATA.encourageHighStandards === null || DATA.encourageHighStandards === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "encourageHighStandardsError",
							error: "A grade is required.",
						})
					);
				}
				if (DATA.toleranceFrustration === null || DATA.toleranceFrustration === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "toleranceFrustrationError",
							error: "A grade is required.",
						})
					);
				}
				if (DATA.organisationOrder === null || DATA.organisationOrder === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "organisationOrderError",
							error: "A grade is required.",
						})
					);
				}
				if (DATA.afterschoolActivities === null || DATA.afterschoolActivities === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "afterschoolActivitiesError",
							error: "A grade is required.",
						})
					);
				}
				if (DATA.workEthic === null || DATA.workEthic === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "workEthicError",
							error: "A grade is required.",
						})
					);
				}
				if (DATA.adaptability === null || DATA.adaptability === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "adaptabilityError",
							error: "A grade is required.",
						})
					);
				}
				if (DATA.teamPlayer === null || DATA.teamPlayer === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "teamPlayerError",
							error: "A grade is required.",
						})
					);
				}
				if (DATA.overallRating === null || DATA.overallRating === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "overallRatingError",
							error: "A grade is required.",
						})
					);
				}
			}
			if (DATA.attendance === null || DATA.attendance === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "attendanceError",
						error: "A grade is required.",
					})
				);
			}
		}
		if (DATA.referenceType === 2) {
			if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.showMedicalReferenceQuestions)) {
				if (DATA.willingToLearn === null || DATA.willingToLearn === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "willingToLearnError",
							error: "A grade is required required.",
						})
					);
				}
				if (DATA.contributionToDepartment === null || DATA.contributionToDepartment === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "contributionToDepartmentError",
							error: "A grade is required required.",
						})
					);
				}
				if (DATA.reliability === null || DATA.reliability === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "reliabilityError",
							error: "A grade is required required.",
						})
					);
				}
				if (DATA.selfMotivation === null || DATA.selfMotivation === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "selfMotivationError",
							error: "A grade is required required.",
						})
					);
				}
				if (DATA.copeUnderPressure === null || DATA.copeUnderPressure === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "copeUnderPressureError",
							error: "A grade is required required.",
						})
					);
				}
				if (DATA.honestyIntegrity === null || DATA.honestyIntegrity === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "honestyIntegrityError",
							error: "A grade is required required.",
						})
					);
				}
				if (DATA.communicationTeamwork === null || DATA.communicationTeamwork === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "communicationTeamworkError",
							error: "A grade is required required.",
						})
					);
				}
				if (DATA.clinicalSkills === null || DATA.clinicalSkills === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "clinicalSkillsError",
							error: "A grade is required required.",
						})
					);
				}
				if (DATA.clinicalKnowledge === null || DATA.clinicalKnowledge === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "clinicalKnowledgeError",
							error: "A grade is required required.",
						})
					);
				}
				if (DATA.organisationalSkills === null || DATA.organisationalSkills === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "organisationalSkillsError",
							error: "A grade is required required.",
						})
					);
				}
				if (DATA.managementSkills === null || DATA.managementSkills === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "managementSkillsError",
							error: "A grade is required required.",
						})
					);
				}
			}
			if (!ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.vidaReferenceQuestions)) {
				if (DATA.profressionalism === null || DATA.profressionalism === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "profressionalismError",
							error: "A grade is required required.",
						})
					);
				}
				if (DATA.relationshipColleagues === null || DATA.relationshipColleagues === undefined) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "relationshipColleaguesError",
							error: "A grade is required required.",
						})
					);
				}
			}
			if (DATA.trustworthy === null || DATA.trustworthy === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "trustworthyError",
						error: "A grade is required required.",
					})
				);
			}
			if (DATA.punctuality === null || DATA.punctuality === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "punctualityError",
						error: "A grade is required required.",
					})
				);
			}
			if (DATA.workWithChildrenSuitability === null || DATA.workWithChildrenSuitability === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "workWithChildrenSuitabilityError",
						error: "A grade is required required.",
					})
				);
			}
			if (DATA.attendance === null || DATA.attendance === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "attendanceError",
						error: "A grade is required.",
					})
				);
			}
		}
		if (DATA.referenceType === 3 || DATA.referenceType == ReferenceTypes.Academic) {
			if (DATA.punctuality === null || DATA.punctuality === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "punctualityError",
						error: "A grade is required required.",
					})
				);
			}
			if (DATA.reliability === null || DATA.reliability === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "reliabilityError",
						error: "A grade is required required.",
					})
				);
			}
			if (DATA.profressionalism === null || DATA.profressionalism === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "profressionalismError",
						error: "A grade is required required.",
					})
				);
			}
			if (DATA.trustworthy === null || DATA.trustworthy === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "trustworthyError",
						error: "A grade is required required.",
					})
				);
			}
			if (DATA.willingnessToLearn === null || DATA.willingnessToLearn === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "willingnessToLearnError",
						error: "A grade is required required.",
					})
				);
			}
			if (DATA.workWithChildrenSuitability === null || DATA.workWithChildrenSuitability === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "workWithChildrenSuitabilityError",
						error: "A grade is required required.",
					})
				);
			}
		}
		if (DATA.referenceType === ReferenceTypes.Volunteer && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.vidaReferenceQuestions)) {
			if (DATA.generalConduct === null || DATA.generalConduct === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "generalConductError",
						error: "A grade is required.",
					})
				);
			}

			if (DATA.workPerformance === null || DATA.workPerformance === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "workPerformanceError",
						error: "A grade is required.",
					})
				);
			}

			if (DATA.attitudeToWork === null || DATA.attitudeToWork === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "attitudeToWorkError",
						error: "A grade is required.",
					})
				);
			}

			if (DATA.initiative === null || DATA.initiative === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "initiativeError",
						error: "A grade is required.",
					})
				);
			}

			if (DATA.timeKeeping === null || DATA.timeKeeping === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "timeKeepingError",
						error: "A grade is required.",
					})
				);
			}

			if (DATA.relationshipColleagues === null || DATA.relationshipColleagues === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "relationshipColleaguesError",
						error: "A grade is required.",
					})
				);
			}

			if (DATA.relationshipCustomers === null || DATA.relationshipCustomers === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "relationshipCustomersError",
						error: "A grade is required.",
					})
				);
			}
		}
	} else if (STEP === 5) {
		if (
			DATA.referenceType === ReferenceSubmissionTypes.Education ||
			DATA.referenceType === ReferenceSubmissionTypes.Professional ||
			DATA.referenceType === ReferenceSubmissionTypes.Factual ||
			DATA.referenceType === ReferenceSubmissionTypes.Academic
		) {
			if (DATA.isCandidateMedicallyUnfit === null || DATA.isCandidateMedicallyUnfit === undefined) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "isCandidateMedicallyUnfitError",
						error: "Candidate medical fitness information is required.",
					})
				);
			}

			if (DATA.isCandidateMedicallyUnfit !== null && DATA.isCandidateMedicallyUnfit !== undefined && DATA.isCandidateMedicallyUnfit && !DATA.candidateMedicalUnfitnessReason?.trim?.()) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "candidateMedicalUnfitnessReasonError",
						error: "Reason for candidate's medical unfitness is required",
					})
				);
			}
		}
	}
	return { valid, errors };
};

export const ValidateReferenceSubmission = (DATA, formQuestions: IFormQuestion[]) => {
	let valid = true,
		errors = [];
	if (!DATA.name) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "nameError",
				error: "Candidate name is required.",
			})
		);
	}
	if (DATA.referenceType === 1 || DATA.referenceType === 2) {
		if (!DATA.dateFrom) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "dateFromError",
					error: "Date started is required.",
				})
			);
		}
		if (!DATA.dateTo) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "dateToError",
					error: "Date left is required.",
				})
			);
		}
		if (!DATA.position) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "positionError",
					error: "Position held is required.",
				})
			);
		}
		if (!DATA.relationship) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "relationshipError",
					error: "Relationship to candidate is required.",
				})
			);
		}
	}
	if (DATA.referenceType === 3) {
		if (!DATA.durationKnown) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "durationKnownError",
					error: "Duration known is required.",
				})
			);
		}
		if (ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.alternativeCharacterReferenceProForma)) {
			if (!DATA.capacityKnown) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "capacityKnownError",
						error: "Capacity known is required.",
					})
				);
			}
			if (!DATA.honestAndReliable) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "honestAndReliableError",
						error: "Honest and reliable field is required.",
					})
				);
			}
			if (!DATA.wouldYouRecommend) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "wouldYouRecommendError",
						error: "Would you recommend field is required.",
					})
				);
			}
		}
	}

	if (DATA.referenceType === 2) {
		if (!DATA.subjectAreas) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "subjectAreas",
					error: "Key responsibilities/duties is required.",
				})
			);
		}
	}
	if (DATA.referenceType === 1 || DATA.referenceType === 2) {
		if (DATA.reEmploy === null || DATA.reEmploy === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "reEmployError",
					error: "An answer is required.",
				})
			);
		}
		if (DATA.reEmploy !== null && DATA.reEmploy !== undefined && !DATA.reEmploy && !DATA.reEmplyDescription) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "reEmployDescriptionError",
					error: "Further details are required.",
				})
			);
		}
		if (DATA.disciplinaryUndergoing === null || DATA.disciplinaryUndergoing === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "disciplinaryUndergoingError",
					error: "An answer is required.",
				})
			);
		}
		if (DATA.disciplinaryUndergoing !== null && DATA.disciplinaryUndergoing !== undefined && DATA.disciplinaryUndergoing && !DATA.disciplinaryUndergoingDescription) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "disciplinaryUndergoingDescriptionError",
					error: "Further details are required.",
				})
			);
		}
	}

	if (DATA.referenceType === 1 && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.vidaReferenceQuestions)) {
		if (DATA.reEmploy !== null && DATA.reEmploy !== undefined && DATA.reEmploy === true && !(DATA.dayToDay || DATA.longTerm || DATA.permanent)) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "reEmployError",
					error: "At least one type must be selected.",
				})
			);
		}
	}

	if (DATA.disciplinaryHistory === null || DATA.disciplinaryHistory === undefined) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "disciplinaryHistoryError",
				error: "An answer is required.",
			})
		);
	}
	if (DATA.disciplinaryHistory !== null && DATA.disciplinaryHistory !== undefined && DATA.disciplinaryHistory && !DATA.disciplinaryHistoryDescription) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "disciplinaryHistoryDescriptionError",
				error: "Further details are required.",
			})
		);
	}
	if (DATA.rejectionReason === null || DATA.rejectionReason === undefined) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "rejectionReasonError",
				error: "An answer is required.",
			})
		);
	}
	if (DATA.rejectionReason !== null && DATA.rejectionReason !== undefined && DATA.rejectionReason && !DATA.rejectionReasonDescription) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "rejectionReasonDescriptionError",
				error: "Further details are required.",
			})
		);
	}

	if (DATA.referenceType === 1) {
		if (DATA.manageClassBehaviour === null || DATA.manageClassBehaviour === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "manageClassBehaviourError",
					error: "A grade is required required.",
				})
			);
		}
		if (DATA.profressionalism === null || DATA.profressionalism === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "profressionalismError",
					error: "A grade is required required.",
				})
			);
		}
		if (DATA.planning === null || DATA.planning === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "planningError",
					error: "A grade is required required.",
				})
			);
		}
		if (DATA.ability === null || DATA.ability === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "abilityError",
					error: "A grade is required required.",
				})
			);
		}
		if (DATA.rapport === null || DATA.rapport === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "rapportError",
					error: "A grade is required required.",
				})
			);
		}
		if (DATA.agencySuitability === null || DATA.agencySuitability === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "agencySuitabilityError",
					error: "A grade is required required.",
				})
			);
		}
	}
	if (DATA.referenceType === 2) {
		if (DATA.profressionalism === null || DATA.profressionalism === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "profressionalismError",
					error: "A grade is required required.",
				})
			);
		}
		if (DATA.relationshipColleagues === null || DATA.relationshipColleagues === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "relationshipColleaguesError",
					error: "A grade is required required.",
				})
			);
		}
		if (DATA.trustworthy === null || DATA.trustworthy === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "trustworthyError",
					error: "A grade is required required.",
				})
			);
		}
		if (DATA.punctuality === null || DATA.punctuality === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "punctualityError",
					error: "A grade is required required.",
				})
			);
		}
		if (DATA.workWithChildrenSuitability === null || DATA.workWithChildrenSuitability === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "workWithChildrenSuitabilityError",
					error: "A grade is required required.",
				})
			);
		}
	}
	if (DATA.referenceType === 3) {
		if (DATA.punctuality === null || DATA.punctuality === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "punctualityError",
					error: "A grade is required required.",
				})
			);
		}
		if (DATA.reliability === null || DATA.reliability === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "reliabilityError",
					error: "A grade is required required.",
				})
			);
		}
		if (DATA.profressionalism === null || DATA.profressionalism === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "profressionalismError",
					error: "A grade is required required.",
				})
			);
		}
		if (DATA.trustworthy === null || DATA.trustworthy === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "trustworthyError",
					error: "A grade is required required.",
				})
			);
		}
		if (DATA.willingnessToLearn === null || DATA.willingnessToLearn === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "willingnessToLearnError",
					error: "A grade is required required.",
				})
			);
		}
		if (DATA.workWithChildrenSuitability === null || DATA.workWithChildrenSuitability === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "workWithChildrenSuitabilityError",
					error: "A grade is required required.",
				})
			);
		}
	}

	if (DATA.referenceType === ReferenceTypes.Volunteer && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.vidaReferenceQuestions)) {
		if (DATA.generalConduct === null || DATA.generalConduct === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "generalConductError",
					error: "A grade is required.",
				})
			);
		}

		if (DATA.workPerformance === null || DATA.workPerformance === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "workPerformanceError",
					error: "A grade is required.",
				})
			);
		}

		if (DATA.attitudeToWork === null || DATA.attitudeToWork === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "attitudeToWorkError",
					error: "A grade is required.",
				})
			);
		}

		if (DATA.initiative === null || DATA.initiative === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "initiativeError",
					error: "A grade is required.",
				})
			);
		}

		if (DATA.timeKeeping === null || DATA.timeKeeping === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "timeKeepingError",
					error: "A grade is required.",
				})
			);
		}

		if (DATA.relationshipColleagues === null || DATA.relationshipColleagues === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "relationshipColleaguesError",
					error: "A grade is required.",
				})
			);
		}

		if (DATA.relationshipCustomers === null || DATA.relationshipCustomers === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "relationshipCustomersError",
					error: "A grade is required.",
				})
			);
		}
	}

	if (!DATA.reffereeName) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "reffereeNameError",
				error: "Your name is required.",
			})
		);
	}
	if (!DATA.reffereeEmail) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "reffereeEmailError",
				error: "Your email is required.",
			})
		);
	}
	if (!DATA.signature) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "signatureError",
				error: "Signature is required.",
			})
		);
	}
	if (DATA.referenceType !== 3) {
		if (!DATA.reffereePosition) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "reffereePositionError",
					error: "Your job role/position is required.",
				})
			);
		}
		if (!DATA.reffereeEmployer) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "reffereeEmployerError",
					error: "Your employer name is required.",
				})
			);
		}
	}
	if (!formQuestions?.find((question) => question.type === FormQuestionModuleType.candidate && question.question === FormQuestionType.noReferenceConsent)) {
		if (DATA.gdprShare === null || DATA.gdprShare === undefined) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "gdprShareError",
					error: "Consent to share response is required.",
				})
			);
		}
	}

	if (DATA.referenceType !== 3 && DATA.reffereePosition) {
		if (!isHeadteacherPosition(DATA.reffereePosition) && !DATA.headteacherConfirmation) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "headteacherConfirmationError",
					error: "You must confirm that the Headteacher / Head of Establishment has had sight of and agrees with this reference.",
				})
			);
		}
	}

	return { valid, errors };
};

export const ValidateBooking = (DATA, formQuestions?: IFormQuestion[]) => {
	let valid = true,
		errors = [];
	if (!DATA.type) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "typeError",
				error: "Booking type is required.",
			})
		);
	}
	if (DATA.type == BookingType.Tutor && !DATA.subType) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "subTypeError",
				error: "Tutor type is required.",
			})
		);
	}
	if (!DATA.draft && !DATA.candidate) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "candidateError",
				error: "Candidate is required.",
			})
		);
	}
	if (!DATA.client) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "clientError",
				error: "Client is required.",
			})
		);
	}
	if (DATA.client && !DATA.clientContact) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "clientContactError",
				error: "Client contact is required.",
			})
		);
	}
	if (DATA.client && DATA.clientRecord && !DATA.clientRecord?.contacts.find((contact) => contact._id === DATA.clientContact)?.email) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "clientContactError",
				error: "Client contact is required.",
			})
		);
	}
	if (!DATA.draft && DATA.client && !DATA.clientAddress?.addressLine1) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "clientAddressLine1Error",
				error: "Client address line 1 is required.",
			})
		);
	}
	if (!DATA.draft && DATA.client && !DATA.clientAddress?.postcode) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "clientAddressPostcodeError",
				error: "Client postcode is required.",
			})
		);
	}
	if (!DATA.draft && DATA.type && DATA.type != BookingType.Interview && ShowFormQuestion(formQuestions, FormQuestionModuleType.candidate, FormQuestionType.healthSafetyBookingRequired)) {
		if (!DATA.healthSafetyCheck) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "healthSafetyCheckError",
					error: "Health and safety confirmation is required.",
				})
			);
		}

		if (DATA.healthSafetyCheck && !DATA.healthSafetyCheckContact) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "healthSafetyCheckContactError",
					error: "Health and safety contact is required.",
				})
			);
		}
	}
	if (!DATA.draft && !DATA.role) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "roleError",
				error: "Role is required.",
			})
		);
	}
	// if (DATA.type === BookingType.Standard && !DATA.awr) {
	// 	valid = false;
	// 	errors.push(
	// 		new FieldValidaionModel({
	// 			name: "awrError",
	// 			error: "AWR duration is required.",
	// 		})
	// 	);
	// }
	if (!DATA.draft && (DATA.type === BookingType.Standard || DATA.type === BookingType.Tutor) && !DATA.chargeRate) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "chargeRateError",
				error: "Charge rate is required.",
			})
		);
	}
	if (!DATA.draft && DATA.type === BookingType.Perm && !DATA.chargeRate) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "chargeRateError",
				error: "Fee amount is required, enter 0 if no fee is required.",
			})
		);
	}
	if (!DATA.draft && (DATA.type === BookingType.Standard || DATA.type === BookingType.Tutor) && !DATA.payRate) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "payRateError",
				error: "Pay rate is required.",
			})
		);
	}
	if (!DATA.draft && DATA.ccsClientBooking && !DATA.buyersReference?.trim()) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "buyersReferenceError",
				error: "Buyer's Reference is required for GCA bookings.",
			})
		);
	}
	if (!DATA.draft && DATA.ccsClientBooking && !DATA.jobType) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "jobTypeError",
				error: "Job Type is required for GCA bookings.",
			})
		);
	}
	if (!DATA.draft && DATA.ccsClientBooking && !DATA.keyStage) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "keyStageError",
				error: "Key Stage is required for GCA bookings.",
			})
		);
	}
	if (!DATA.draft && DATA.ccsClientBooking && !DATA.feeType) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "feeTypeError",
				error: "Fee Type is required for GCA bookings.",
			})
		);
	}
	if (!DATA.draft && DATA.ccsClientBooking && (typeof DATA.curriculumSubject !== "string" || !DATA.curriculumSubject.trim() || DATA.curriculumSubject.trim().length > 256)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "curriculumSubjectError",
				error: "Enter a Curriculum Subject (up to 256 characters) for GCA bookings.",
			})
		);
	}
	if (!DATA.draft && DATA.ccsClientBooking && DATA.type !== BookingType.Perm && !DATA.agencyFee) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "agencyFeeError",
				error: "Agency Fee is required for GCA bookings.",
			})
		);
	}
	if (!DATA.draft && (DATA.type === BookingType.Standard || DATA.type === BookingType.Tutor) && !DATA.candidatePayType) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "candidatePayTypeError",
				error: "Candidate pay type (paye/ umbrella) is required.",
			})
		);
	}
	if ((DATA.type === BookingType.Interview || DATA.type === BookingType.Trial) && DATA.salary && !DATA.salaryPayType) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "salaryPayTypeError",
				error: "Salary pay type (annual/ daily) is required.",
			})
		);
	}
	if (!DATA.days || !DATA.days.length) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "daysError",
				error: "At least 1 day is required to make a booking.",
			})
		);
	}
	if (DATA.type === BookingType.Perm && DATA.days?.length && DATA.days?.length > 1) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "daysError",
				error: "Only select the start date for permanent placements.",
			})
		);
	}
	return { valid, errors };
};

export const ValidatePlaceholderBooking = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.client) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "clientError",
				error: "Client is required.",
			})
		);
	}
	if (!DATA.occupation) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "occupationError",
				error: "Occupation is required.",
			})
		);
	}
	if (!DATA.days || !DATA.days.length) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "daysError",
				error: "At least 1 day is required to make a booking.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateConvertBooking = (DATA) => {
	let valid = true,
		errors = [];
	if (DATA.type === BookingType.Perm && !DATA.chargeRate) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "chargeRateError",
				error: "Fee amount is required.",
			})
		);
	}
	if ((DATA.type === BookingType.Standard || DATA.type === BookingType.Tutor) && !DATA.chargeRate) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "chargeRateError",
				error: "Charge rate is required.",
			})
		);
	}
	if ((DATA.type === BookingType.Standard || DATA.type === BookingType.Tutor) && !DATA.payRate) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "payRateError",
				error: "Pay rate is required.",
			})
		);
	}
	if ((DATA.type === BookingType.Standard || DATA.type === BookingType.Tutor) && !DATA.candidatePayType) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "candidatePayTypeError",
				error: "Candidate pay type (paye/ umbrella) is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateTimesheet = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.candidateName || !DATA.candidateName.trim()) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "candidateNameError",
				error: "Candidate is required.",
			})
		);
	}
	if (!DATA.candidate) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "candidateError",
				error: "Candidate is required.",
			})
		);
	}
	if (!DATA.clientName || !DATA.clientName.trim()) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "clientNameError",
				error: "Client is required.",
			})
		);
	}
	if (!DATA.clientEmail || !DATA.clientEmail.trim()) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "clientEmailError",
				error: "Client email is required.",
			})
		);
	}
	if (DATA.clientEmail && !IsEmail(DATA.clientEmail)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "clientEmailError",
				error: "Client email is not a valid email address.",
			})
		);
	}
	if (!DATA.client) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "clientError",
				error: "Client is required.",
			})
		);
	}
	if (!DATA.booking) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "bookingError",
				error: "Booking is required.",
			})
		);
	}
	if (!DATA.days || !DATA.days.length) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "daysError",
				error: "The period of time the timesheet covers is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateTemplate = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.name) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "nameError",
				error: "Template name is required.",
			})
		);
	}
	if (!DATA.category) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "categoryError",
				error: "Template category is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateSingleSend = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.name) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "nameError",
				error: "Template name is required.",
			})
		);
	}
	if (!DATA.subject) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "subjectError",
				error: "Email subject is required.",
			})
		);
	}
	if (!DATA.recipients || !DATA.recipients.length) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "recipientsError",
				error: "At least one recipient is required.",
			})
		);
	}
	if (!DATA.template) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "templateError",
				error: "Email template is required.",
			})
		);
	}
	if (DATA.scheduleDate && !DATA.scheduleTime) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "scheduleTimeError",
				error: "Schedule Date and Time is required.",
			})
		);
	}
	if (DATA.scheduleTime && !IsValidTime(DATA.scheduleTime)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "scheduleTimeError",
				error: "Schedule Date and Time is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateMeAccount = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.firstName) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "firstNameError",
				error: "First name is required.",
			})
		);
	}
	if (!DATA.lastName) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "lastNameError",
				error: "Last name is required.",
			})
		);
	}
	if (!DATA.email) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "emailError",
				error: "Email is required.",
			})
		);
	} else {
		if (!IsEmail(DATA.email)) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "emailError",
					error: "Please enter a valid email address.",
				})
			);
		}
	}
	if (!DATA.username) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "usernameError",
				error: "Username is required.",
			})
		);
	}
	if (DATA.phone && isInvalidPhoneNumber(DATA.phone)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "phoneError",
				error: "Please enter a valid phone number.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateCustomerAccount = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.name) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "nameError",
				error: "Company name is required.",
			})
		);
	}
	if (DATA.contactEmail && !IsEmail(DATA.contactEmail)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "contactEmailError",
				error: "Please enter a valid email address.",
			})
		);
	}
	if (DATA.contactTelephone && !IsTelephone(DATA.contactTelephone)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "contactTelephoneError",
				error: "Please enter a valid telephone number.",
			})
		);
	}
	if (!DATA.logo) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "logoError",
				error: "Company logo is required.",
			})
		);
	}
	if (!DATA.address) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "addressError",
				error: "Company address is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateExternalComms = (DATA) => {
	let valid = true,
		errors = [];

	if (DATA.onboardingEmail && !IsEmail(DATA.onboardingEmail)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "onboardingEmailError",
				error: "Please enter a valid email address for onboarding communications.",
			})
		);
	}

	if (DATA.referenceEmail && !IsEmail(DATA.referenceEmail)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "referenceEmailError",
				error: "Please enter a valid email address for reference requests.",
			})
		);
	}

	if (DATA.timesheetEmail && !IsEmail(DATA.timesheetEmail)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "timesheetEmailError",
				error: "Please enter a valid email address for timesheet communications.",
			})
		);
	}

	return { valid, errors };
};

export const ValidateUser = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.firstName) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "firstNameError",
				error: "First name is required.",
			})
		);
	}
	if (!DATA.lastName) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "lastNameError",
				error: "Last name is required.",
			})
		);
	}
	if (!DATA.username) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "usernameError",
				error: "Username is required.",
			})
		);
	}
	if (!DATA.email) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "emailError",
				error: "Email is required.",
			})
		);
	}
	if (DATA.email && !IsEmail(DATA.email)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "emailError",
				error: "Please enter a valid email address.",
			})
		);
	}
	if (!DATA.position) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "positionError",
				error: "Job title is required.",
			})
		);
	}
	if (DATA.commissionThreshold === null || DATA.commissionThreshold === undefined) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "commissionThresholdError",
				error: "Commission threshold is required. This value can be 0.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateCommission = (DATA: ICommission) => {
	let valid = true,
		errors = [];
	if (!DATA.min) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "minError",
				error: "Commission threshold value is required.",
			})
		);
	}
	if (!DATA.commission) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "commissionError",
				error: "A percentage commission is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateImageUpload = (DATA) => {
	let valid = true,
		errors = [];
	if (!(DATA.type === "image/jpeg" || DATA.type === "image/png" || DATA.type === "image/jpg")) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "imageError",
				error: "The selected file must be a jpeg or png.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateDocumentUploadType = (DATA, validTypes) => {
	let valid = true,
		errors = [];
	if (!validTypes.includes(DATA.type)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "imageError",
				error: "The selected file must be one of the following types: " + validTypes.join(", "),
			})
		);
	}
	return { valid, errors };
};

export const ValidateBookingCosts = (DATA) => {
	let valid = true,
		errors = [];
	if (DATA.oncosts) {
		if (isNaN(DATA.oncosts)) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "oncostsError",
					error: "Booking on-costs must be a number.",
				})
			);
		} else {
			if (parseFloat(DATA.oncosts) < 0 || parseFloat(DATA.oncosts) > 100) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "oncostsError",
						error: "Booking on-costs must be between 0 and 100.",
					})
				);
			}
		}
	}
	if (DATA.umbrellaAssignmentFee) {
		if (isNaN(DATA.umbrellaAssignmentFee)) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "umbrellaAssignmentFeeError",
					error: "Umbrella assignment fee must be a number.",
				})
			);
		} else {
			if (parseFloat(DATA.umbrellaAssignmentFee) < 0 || parseFloat(DATA.umbrellaAssignmentFee) > 100) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "umbrellaAssignmentFeeError",
						error: "Umbrella assignment fee must be between 0 and 100.",
					})
				);
			}
		}
	}
	return { valid, errors };
};

export const ValidateBookingCostsHoliday = (DATA: BookingCostsHolidayInterface) => {
	let valid = true,
		errors = [];
	if (DATA.holidayPay) {
		if (DATA.holidayPayPercentage && isNaN(DATA.holidayPayPercentage)) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "holidayPayPercentageError",
					error: "Holiday pay percentage must be a number.",
				})
			);
		} else {
			if (DATA.holidayPayPercentage) {
				if (parseFloat(DATA.holidayPayPercentage.toString()) < 0 || parseFloat(DATA.holidayPayPercentage.toString()) > 100) {
					valid = false;
					errors.push(
						new FieldValidaionModel({
							name: "holidayPayPercentageError",
							error: "Holiday pay percentage must be between 0 and 100.",
						})
					);
				}
			}
		}
	}
	return { valid, errors };
};

export const ValidateBookingCostsRatesAmend = (DATA: IRates) => {
	let valid = true,
		errors = [];
	if (!DATA?.payRate && !DATA?.chargeRate) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "payRateError",
				error: "Pay rate and/ or Charge rate % change is required",
			})
		);
		errors.push(
			new FieldValidaionModel({
				name: "chargeRateError",
				error: "Chare rate and/ or Pay rate % change is required",
			})
		);
	}
	return { valid, errors };
};

export const ValidateContractForService = (DATA: IContractForService) => {
	let valid = true,
		errors = [];
	if (!DATA.contractForService) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "contractForServiceError",
				error: "A valid contract for service PDF must be uploaded.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateTermsOfBusiness = (DATA: ITermsOfBusiness) => {
	let valid = true,
		errors = [];
	if (!DATA.termsOfBusiness) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "termsOfBusinessError",
				error: "A valid terms of business PDF must be uploaded.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateBulkTimesheetCreation = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.bookings || !DATA.bookings.length) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "oncostsError",
				error: "Booking on-costs is required.",
			})
		);
	}
	if (DATA.bookings.length) {
		const missingClientEmails = DATA.bookings
			.filter(
				(booking) =>
					!(
						booking.clientRecord?.contacts.find((contact) => contact._id === booking.timesheetContact)?.email ||
						booking.clientRecord?.contacts.find((contact) => contact._id === booking.clientContact)?.email
					)
			)
			.map(
				(booking) =>
					new FieldValidaionModel({
						name: "bookingsError",
						error: `${booking.candidateName}: Client contact is missing from the booking.`,
					})
			);
		if (missingClientEmails.length) {
			valid = false;
			errors = [...errors, ...missingClientEmails];
		}

		const missingCandidateEmails = DATA.bookings
			.filter((booking) => !booking.candidate)
			.map(
				(booking) =>
					new FieldValidaionModel({
						name: "bookingsError",
						error: `${booking.candidateName}: Candidate email is missing from the booking.`,
					})
			);
		if (missingCandidateEmails.length) {
			valid = false;
			errors = [...errors, ...missingCandidateEmails];
		}
	}
	return { valid, errors };
};

export const ValidateXeroContact = (DATA: IXeroClientContact) => {
	let valid = true,
		errors = [];
	if (!DATA.name) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "nameError",
				error: "Client name is required.",
			})
		);
	}
	if (!DATA.email) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "emailError",
				error: "Please enter a valid email address.",
			})
		);
	}
	if (DATA.email && !IsEmail(DATA.email)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "emailError",
				error: "Please enter a valid email address.",
			})
		);
	}
	if (!DATA.firstName) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "firstNameError",
				error: "First Name is required.",
			})
		);
	}
	if (!DATA.lastName) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "lastNameError",
				error: "Last Name.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateXeroInvoice = (DATA: IInvoice & { accountCode: string; invoices: IInvoice[] }) => {
	let valid = true,
		errors = [];
	// if (!DATA.contact) {
	// 	valid = false;
	// 	errors.push(
	// 		new FieldValidaionModel({
	// 			name: "contactError",
	// 			error: "Client contact is required.",
	// 		})
	// 	);
	// }
	if (!DATA.date) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "dateError",
				error: "Invoice date is required.",
			})
		);
	}
	if (!DATA.dueDate) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "dueDateError",
				error: "Due date is required.",
			})
		);
	}
	// if (!DATA.invoiceNumber) {
	// 	valid = false;
	// 	errors.push(
	// 		new FieldValidaionModel({
	// 			name: "invoiceNumberError",
	// 			error: "Invoice number is required.",
	// 		})
	// 	);
	// }
	// if (!DATA.lineItems || !DATA.lineItems.length) {
	// 	valid = false;
	// 	errors.push(
	// 		new FieldValidaionModel({
	// 			name: "lineItemsError",
	// 			error: "At least 1 invoice line item is required.",
	// 		})
	// 	);
	// }
	if (!DATA.invoices || !DATA.invoices.length) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "invoicesError",
				error: "At least 1 invoice record is required.",
			})
		);
	}
	if (DATA.invoices?.length) {
		if (DATA.invoices.filter((invoice) => !invoice.lineItems?.length).length) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "invoicesError",
					error: "At least 1 invoice line item is required.",
				})
			);
		}
		if (DATA.invoices.filter((invoice) => !invoice.contact).length) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "invoicesError",
					error: "Invoice contacts are required for all selected invoices. Be sure to select or create contacts for the invoices below. Once the contacts have been created for a client you will be able to select them for future invoicies.",
				})
			);
		}
	}
	if (!DATA.accountCode) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "accountCodeError",
				error: "A valid account must be selected.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateXeroLineItem = (DATA: ILineItem & { duration?: string }) => {
	let valid = true,
		errors = [];
	if (!DATA.unitAmount) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "unitAmountError",
				error: "Line item amount is required.",
			})
		);
	}
	if (!DATA.duration) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "descriptionError",
				error: "Line item description is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidatePaymentRun = (DATA) => {
	let valid = true,
		errors = [];
	if (!DATA.timesheets || !DATA.timesheets.length) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "timesheetsError",
				error: "At least one record is required to create a payment run.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateCustomId = (DATA: { _customId: string }) => {
	let valid = true,
		errors = [];
	if (!DATA._customId) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "customIdError",
				error: "Custom ID is required.",
			})
		);
	}
	if (DATA._customId && DATA._customId.trim().length < 2) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "customIdError",
				error: "Custom ID must contain at least 2 characters.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateBranch = (DATA: IBranch) => {
	let valid = true,
		errors = [];
	if (!DATA.name) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "nameError",
				error: "Team name is required.",
			})
		);
	}
	// if (DATA.contactWebsite && !IsWebSite(DATA.contactWebsite)) {
	// 	valid = false;
	// 	errors.push(
	// 		new FieldValidaionModel({
	// 			name: "websiteError",
	// 			error: "Please enter a valid website url.",
	// 		})
	// 	);
	// }
	// if (!DATA.address) {
	// 	valid = false;
	// 	errors.push(
	// 		new FieldValidaionModel({
	// 			name: "addressLine1Error",
	// 			error: "Address Line 1 is required.",
	// 		})
	// 	);
	// 	errors.push(
	// 		new FieldValidaionModel({
	// 			name: "postcodeError",
	// 			error: "Postcode is required.",
	// 		})
	// 	);
	// } else {
	// 	if (!DATA.address.addressLine1) {
	// 		valid = false;
	// 		errors.push(
	// 			new FieldValidaionModel({
	// 				name: "addressLine1Error",
	// 				error: "Address Line 1 is required.",
	// 			})
	// 		);
	// 	}
	// 	if (!DATA.address.postcode) {
	// 		valid = false;
	// 		errors.push(
	// 			new FieldValidaionModel({
	// 				name: "postcodeError",
	// 				error: "Postcode is required.",
	// 			})
	// 		);
	// 	}
	// }
	// if (DATA.contactWebsite && !IsWebSite(DATA.contactWebsite)) {
	// 	valid = false;
	// 	errors.push(
	// 		new FieldValidaionModel({
	// 			name: "websiteError",
	// 			error: "Please enter a valid website url.",
	// 		})
	// 	);
	// }
	return { valid, errors };
};

export const ValidateUmbrellaCreate = (DATA: IUmbrella) => {
	let valid = true,
		errors = [];
	if (!DATA.name) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "nameError",
				error: "Umbrella name is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateTargetCreate = (DATA: ITarget) => {
	let valid = true,
		errors = [];
	if (!DATA.start) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "startError",
				error: "Target coverage is required.",
			})
		);
	}
	if (!DATA.type) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "typeError",
				error: "Target type is required.",
			})
		);
	}
	if (!DATA.value) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "valueError",
				error: "Target value is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateFileUpload = (size: number, type: string, maxSize: number, acceptedFileTypes: string[]) => {
	let valid = true,
		errors = [];
	if (size && !ValidateFileSize(size, maxSize)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "fileSizeError",
				error: `The file size exceeds the maximum limit of ${maxSize}MB. Please reduce the file size or choose a different file and try again`,
			})
		);
	}
	if (type && !ValidateFileType(type, acceptedFileTypes)) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "fileTypeError",
				error: "The file type is not supported. Please upload a file in standard document or image formats (e.g., PDF, DOC, JPEG, PNG) and try again.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateCandidateEnquiryCreate = (DATA: CandidateEnquiryInterface, formQuestions: IFormQuestion[]) => {
	let valid = true,
		errors = [];
	if (!DATA.forename) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "forenameError",
				error: "First name is required.",
			})
		);
	}
	if (!DATA.surname) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "surnameError",
				error: "Surname is required.",
			})
		);
	}
	if (!DATA.email) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "emailError",
				error: "Email is required.",
			})
		);
	} else {
		if (!IsEmail(DATA.email)) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "emailError",
					error: "Please enter a valid email address.",
				})
			);
		}
	}
	if (!IsNonUk(formQuestions)) {
		if (!DATA.address) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "addressLine1Error",
					error: "Address Line 1 is required.",
				})
			);
			errors.push(
				new FieldValidaionModel({
					name: "postcodeError",
					error: "Postcode is required.",
				})
			);
		} else {
			if (!DATA.address.addressLine1) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "addressLine1Error",
						error: "Address Line 1 is required.",
					})
				);
			}
			if (!DATA.address.postcode) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "postcodeError",
						error: "Postcode is required.",
					})
				);
			}
		}
	} else {
		if (!DATA.address) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "countryError",
					error: "Country is required.",
				})
			);
		} else {
			if (!DATA.address.country) {
				valid = false;
				errors.push(
					new FieldValidaionModel({
						name: "countryError",
						error: "Country is required.",
					})
				);
			}
		}
	}
	return { valid, errors };
};

export const ValidateCandidateInterviewConfirmation = (DATA: ICandidateInterviewQuestions, formQuestions: IFormQuestion[]) => {
	let valid = true,
		errors = [];
	if (!DATA?.candidateApprovalSignature?.trim() && !DATA?.candidateApprovalNote?.trim()) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "candidateApprovalSignatureError",
				error: "Signature or approval note is required.",
			})
		);
	}
	if (!DATA?.candidateApprovalDrawnSignature && !DATA?.candidateApprovalNote?.trim()) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "candidateApprovalDrawnSignatureError",
				error: "Signature or approval note is required.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateOrganisationReference = (DATA: { references: string[] }) => {
	let valid = true,
		errors = [];
	if (!DATA.references) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "referenceError",
				error: "Organisation reference is required.",
			})
		);
	}

	for (const ref of DATA.references) {
		if (!/^\w{1,30}$/.test(ref)) {
			valid = false;
			errors.push(
				new FieldValidaionModel({
					name: "referenceError",
					error: "References must be 1-30 characters long and contain only letters, numbers, and underscores.",
				})
			);
			break;
		}
	}
	return { valid, errors };
};

export const ValidateDocumentCitationCompliance = (DATA: DocumentInterface) => {
	let valid = true,
		errors = [];
	if (!canCiteDocument(DATA.docType as unknown as RightToWork)) {
		return { valid, errors };
	}
	if (!DATA.citedOriginalDocumentation) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "citedOriginalDocumentationError",
				error: "You must confirm that original documentation was cited before approving this document.",
			})
		);
	}
	if (!DATA.citedOriginalDocumentationDate) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "citedOriginalDocumentationDateError",
				error: "You must provide a citation date before approving this document.",
			})
		);
	}
	if (!DATA.methodOfCitation) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "methodOfCitationError",
				error: "You must select a method of citation before approving this document.",
			})
		);
	}
	if (
		(DATA.methodOfCitation === MethodOfCitation.LiveVideo || DATA.methodOfCitation === MethodOfCitation.DayOneReconciliation) &&
		(!DATA.reasonForCitationMethod || DATA.reasonForCitationMethod.trim() === "")
	) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "reasonForCitationMethodError",
				error: "You must provide a reason for the citation method.",
			})
		);
	}
	return { valid, errors };
};

export const ValidateClientTermsOfBusiness = (DATA, errors: FieldValidaionModel[]) => {
	let valid = true;
	if (!DATA.termsOfBusinessConsentName) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "termsOfBusinessConsentName",
				error: "Signature is required.",
			})
		);
	}
	if (!DATA.termsOfBusinessConsentSignature) {
		valid = false;
		errors.push(
			new FieldValidaionModel({
				name: "termsOfBusinessConsentSignature",
				error: "Signature is required.",
			})
		);
	}
	return { valid, errors };
};
